export default {
  spanish: 'الإسبانية',
  english: 'الإنجليزية',
  french: 'الفرنسية',
  german: 'الألمانية',
  chinese: 'الصينية',
  addPrinter: {
    title: 'إضافة طابعة',
    detectPrinters: 'كشف الطابعات تلقائياً',
    printerName: 'اسم الطابعة',
    printerType: 'نوع الطابعة',
    laser: 'طابعة ليزر',
    receipt: 'طابعة فواتير',
    barcode: 'طابعة باركود',
    connectionType: 'نوع الاتصال',
    network: 'شبكة',
    ipAddress: 'عنوان IP',
    port: 'المنفذ',
    driverType: 'نوع التعريف',
    printSpeed: 'سرعة الطباعة',
    autoCutter: 'قاطع ورق آلي',
    cashDrawerPort: 'منفذ الدرج النقدي',
    printDensity: 'كثافة الطباعة',
    savePrinter: 'حفظ الطابعة',
    detectionCompleted: 'تم اكتشاف الطابعات بنجاح.',
    fillAllFields: 'الرجاء ملء جميع الحقول المطلوبة.',
    success: 'تمت إضافة الطابعة بنجاح!',
    scanning: 'جاري البحث عن الطابعات...',
    detectionSuccess: 'تم اكتشاف الطابعة بنجاح!',
    noPrintersFound: 'لم يتم العثور على طابعات.',
    detectionError: 'حدث خطأ أثناء اكتشاف الطابعات.'
  },
  backoffice: {
    printerManager: {
      title: "مدير الطابعات",
      printers: "الطابعات",
      select: "اختيار",
      discoverPrinters: "البحث عن الطابعات",
      showAddPrinter: "إضافة طابعة",
      printTest: "طباعة صفحة اختبار",
      scanBluetooth: "البحث عن طابعات بلوتوث",
      printerName: "اسم الطابعة",
      printerType: "نوع الطابعة",
      laser: "طابعة ليزر (A4)",
      receipt: "طابعة إيصالات",
      barcode: "طابعة باركود",
      autoCutter: "قاطع تلقائي",
      driverType: "نوع برنامج التشغيل",
      connectionType: "نوع الاتصال",
      ipAddress: "عنوان IP",
      port: "منفذ",
      mac: "عنوان MAC",
      isDefault: "افتراضي",
      add: "إضافة",
      cancel: "إلغاء",
      noPrintersFound: "لم يتم العثور على طابعات.",
      printSentSuccess: "تم إرسال الطباعة بنجاح إلى طابعة الشبكة.",
      printFailedBackend: "فشلت الطباعة في الخادم.",
      networkPrintError: "خطأ في طباعة الشبكة: {error}",
      usbPrintError: "خطأ في طباعة USB. تحقق من الاتصالات!",
      noUSBPrinters: "لم يتم اكتشاف طابعات USB!",
      bluetoothPrintError: "خطأ في طباعة البلوتوث. تحقق من الاتصال!",
      printFailed: "فشلت الطباعة. يرجى التحقق من اتصال الطابعة والمحاولة مرة أخرى.",
      selectPrinterType: "اختيار Printer Connection Type",
      inputPlaceholder: "اختيار a type connection",
      pleaseSelectPrinterType: "يرجى اختيار نوع الطابعة.",
      invalidPrinterType: "تم اختيار نوع طابعة غير صالح.",
      scannedFromBLE: "تم المسح من BLE: {barcode}"
    },
    bleScanner: {
      title: "ماسح وطابعة BLE",
      deviceType: "نوع الجهاز",
      scanner: "ماسح الباركود",
      printer: "طابعة",
      scanDevices: "البحث عن أجهزة BLE",
      unnamedDevice: "جهاز بدون اسم",
      connect: "[AR] Connect",
      scannedBarcode: "الباركود الممسوح:",
      printData: "بيانات الطباعة",
      enterPrintText: "أدخل نصًا للطباعة",
      sendToPrinter: "إرسال إلى الطابعة",
      bleScanError: "خطأ في مسح BLE: {error}",
      connectionSuccess: "تم الاتصال بـ {device}",
      connectionError: "خطأ في الاتصال: {error}",
      notificationError: "خطأ في الإشعار: {error}",
      scanned: "تم المسح: {barcode}",
      noPrinterOrData: "لا توجد طابعة متصلة أو بيانات الطباعة فارغة.",
      printDataSent: "تم إرسال بيانات الطباعة إلى الطابعة.",
      printError: "خطأ في الطباعة: {error}"
    },
    interactions: {
      lastContacted: 'آخر اتصال',
      notesLastContacted: 'ملاحظات آخر اتصال',
      nextFollowUp: 'التواصل التالي',
      notesNextFollowUp: 'ملاحظات التواصل التالي',
      preferredContactTime: 'وقت الاتصال المفضل',
      notesContactToTime: 'ملاحظات وقت الاتصال المفضل', 
      selectSubscriber: 'حدد المشترك',
      selectSubscriberDescription: 'حدد المشترك لإضافته أو عرض معلوماته',
      selectSubscriberInput: 'حدد المشترك',
      selectSubscriberInputPlaceholder: 'حدد المشترك',
      createSubscriber: 'إنشاء عضو',
      cancel: 'إلغاء',
      //customers
      selectCustomer: 'حدد العميل',
      selectCustomerDescription: 'حدد العميل لإضافته أو عرض معلوماته',
      selectCustomerInput: 'حدد العميل',
      selectCustomerInputPlaceholder: 'حدد العميل',
      createCustomer: 'إنشاء عميل',
    },
    cCardSaved:{
      paymentManagement: 'إدارة الدفع',
      clickToManageCards: 'انقر هنا لإضافة أو عرض بطاقاتك المسجلة',
      creditCards: 'بطاقات الائتمان',
      addCreditCard: 'إضافة بطاقة ائتمان',
    },
    virtualTerminal: {
      acordeon1: {
        title: 'معلومات الدفع/التفويض',
        subtitle: 'طرق الدفع المقبولة: أمريكان إكسبريس، ديسكفر، ماستركارد',
        cardNumber: 'رقم البطاقة',
        expirationDate: 'تاريخ الانتهاء',
        amount: 'المبلغ'
      },
      acordeon2: {
        title: 'معلومات الطلب',
        subscriptionName: 'اسم الاشتراك',
        invoice: 'رقم الفاتورة',
        description: 'الوصف',
        placeholder: 'أدخل المزيد من المعلومات هنا...'
      },
      acordeon3: {
        title: 'فترة الاشتراك',
        subtitle: 'حدد عدد مرات الفترة التي سيتم فيها تحصيل المبلغ من العميل.',
        selectOption: 'اختر خيارًا',
        interval1: 'شهري',
        interval2: 'ربع سنوي',
        interval3: 'نصف سنوي',
        interval4: 'سنوي'
      },
      acordeon4: {
        title: 'مدة الاشتراك',
        startDate: 'تاريخ البدء',
        noEnd: 'لا يوجد تاريخ انتهاء (اشتراك مستمر)',
        endDate: 'تاريخ الانتهاء',
        endAfter: 'ينتهي بعد'
      },
      acordeon5: {
        title: 'الدفع',
        nameAcount: 'اسم صاحب الحساب',
        paymentType: 'نوع الدفع',
        creditCard: 'بطاقة ائتمان',
        subscriptionName: 'اسم الاشتراك',
        trialAmount: 'مبلغ التجربة',
        firstName: 'الاسم الأول',
        sameAsBilling: 'مطابق لعنوان الفاتورة'
      }
    },
    worksheetStatus: {
      draft: 'مسودة',
      opened: 'مفتوح',
      closed: 'مغلق',
      worksheetDetail: 'تفاصيل ورقة العمل',
      fields: {
        responsable: 'المسؤول',
        startDate: 'تاريخ البدء',
        endDate: 'تاريخ الانتهاء',
        workers: 'العمال'
      },
      tooltip: {
        staffWorker: 'إضافة موظف',
        resetAllCalendar: 'إعادة تعيين جميع التقويمات',
        showCalendarDetails: 'عرض تفاصيل التقويم',
        resetCalendar: 'إعادة تعيين هذا التقويم',
        removeStaffWorker: 'إزالة موظف',
        debit: 'هذه هي مصروفاتك. الأموال التي يتم صرفها.',
        credit: 'هذه هي إيراداتك. الأموال التي تأتيك.',
        payee: 'هذا هو الشخص الذي دفع لك أو الذي دفعت له.',
        category: 'هذا هو نوع الدفع أو الائتمان.',
        bestRepresentation: 'هذا هو أفضل تخمين للنظام لفئة المعاملة.'
      },
      message: {
        totalHour: 'إجمالي ساعات العمل:',
        hours: 'ساعات',
        with: 'مع',
        minutes: 'دقائق',
        typeMessage: 'اكتب الرسالة هنا...'
      },
      button: {
        saveDraft: 'حفظ كمسودة',
        saveOpen: 'حفظ وفتح',
        close: 'إغلاق',
        addShift: 'إضافة وردية',
        changeworksheetRequest: 'طلب تغيير'
      }
    },
    mastercard: {
      accountInfo: 'معلومات الحساب',
      mastercardUserDetails: 'تفاصيل مستخدم ماستركارد',
      seeLinedAccounts: 'عرض الحسابات المرتبطة',
      addMoreBanks: 'إضافة المزيد من البنوك',
      linkedBanks: 'الحسابات المرتبطة',
      viewTransactions: 'عرض المعاملات',
      linesPerPage: 'عدد الأسطر في الصفحة'
    },
    transactionData: {
      revenue: "الإيرادات",
      revenueDescription: "قم بتبديل هذا المفتاح إذا كانت المعاملة عبارة عن إدخال إيرادات.",
      transactionId: "معرف المعاملة",
      transactionIdDescription: "أدخل معرف المعاملة الفريد المرتبط بهذه المعاملة.",
      transactionAmount: "مبلغ المعاملة (دولار أمريكي)",
      transactionAmountDescription: "أدخل مبلغ المعاملة بالدولار الأمريكي. هذا هو المبلغ المتضمن في المعاملة.",
      accountId: "معرف الحساب",
      accountIdDescription: "أدخل معرف الحساب الفريد المرتبط بالمعاملة.",
      customerId: "معرف العميل",
      customerIdDescription: "أدخل معرف العميل الفريد المرتبط بالمعاملة.",
      transactionStatus: "حالة المعاملة",
      transactionStatusDescription: "حدد الحالة الحالية للمعاملة من الخيارات المتاحة.",
      statusOptions: {
        active: "نشط",
        pending: "قيد الانتظار",
        completed: "مكتمل",
        failed: "فشل",
        cancelled: "ملغى"
      },
      memo: "مذكرة",
      memoDescription: "أدخل أي ملاحظات إضافية أو مذكرة للمعاملة.",
      transactionType: "نوع المعاملة",
      transactionTypeDescription: "حدد نوع المعاملة لهذه المعاملة.",
      transactionDate: "تاريخ المعاملة",
      transactionDateDescription: "حدد التاريخ الذي حدثت فيه المعاملة.",
      typeOptions: {
        debit: "مدين",
        credit: "دائن",
        transfer: "تحويل",
        payment: "دفع",
        withdrawal: "سحب",
        deposit: "إيداع"
      },
      postedDate: "تاريخ النشر",
      postedDateDescription: "حدد التاريخ الذي تم فيه نشر المعاملة.",
      createdDate: "تاريخ الإنشاء",
      createdDateDescription: "حدد التاريخ الذي تم فيه إنشاء المعاملة.",
      firstEffectiveDate: "تاريخ السريان الأول",
      firstEffectiveDateDescription: "حدد تاريخ السريان الأول للمعاملة.",
      effectiveDate: "تاريخ السريان",
      effectiveDateDescription: "حدد تاريخ السريان للمعاملة.",
      optionExpireDate: "تاريخ انتهاء الخيار",
      optionExpireDateDescription: "حدد تاريخ انتهاء الخيار إذا كان مطبقًا.",
      checkNumber: "رقم الشيك",
      checkNumberDescription: "أدخل رقم الشيك إذا كان مطبقًا. اتركه فارغًا إذا لم يكن مطبقًا.",
      escrowAmount: "مبلغ الضمان (دولار أمريكي)",
      escrowAmountDescription: "أدخل مبلغ الضمان إذا كان مطبقًا. هذا هو المبلغ المحتفظ به في الضمان للمعاملة.",
      transactionFeeAmount: "مبلغ رسوم المعاملة (دولار أمريكي)",
      transactionFeeAmountDescription: "أدخل مبلغ الرسوم إذا كان مطبقًا. هذه هي الرسوم المفروضة لمعالجة المعاملة.",
      suspenseAmount: "مبلغ مؤقت (دولار أمريكي)",
      suspenseAmountDescription: "أدخل المبلغ المؤقت إذا كان مطبقًا. هذا يستخدم للمعاملات التي يتم الاحتفاظ بها مؤقتًا أو معلقة.",
      interestAmount: "مبلغ الفائدة (دولار أمريكي)",
      interestAmountDescription: "أدخل مبلغ الفائدة إذا كان مطبقًا. هذا هو مبلغ الفائدة المتراكمة على المعاملة.",
      principalAmount: "المبلغ الأصلي (دولار أمريكي)",
      principalAmountDescription: "أدخل المبلغ الأصلي إذا كان مطبقًا. هذا هو المبلغ الأصلي المقترض أو المستثمر، باستثناء أي فوائد أو رسوم.",
      optionStrikePrice: "سعر إنجاز الخيار (دولار أمريكي)",
      optionStrikePriceDescription: "أدخل سعر إنجاز الخيار إذا كان مطبقًا. هذا هو السعر الذي يمكن به تنفيذ الخيار.",
      unitQuantity: "كمية الوحدة",
      unitQuantityDescription: "أدخل كمية الوحدة إذا كان مطبقًا. هذا هو عدد الوحدات المتضمنة في المعاملة، مثل العناصر المشتراة أو الأسهم المتداولة.",
      unitPrice: "سعر الوحدة (دولار أمريكي)",
      unitPriceDescription: "أدخل سعر الوحدة إذا كان مطبقًا. هذا يستخدم للمعاملات التي تتضمن أوراقًا مالية أو استثمارات.",
      transactionCategorization: "تصنيف المعاملة",
      normalizedPayeeName: "اسم المستفيد الموحد",
      normalizedPayeeNameDescription: "أدخل اسم المستفيد بتنسيق موحد. هذا مفيد لضمان الاتساق في السجلات.",
      transactionCategory: "فئة المعاملة",
      transactionCategoryDescription: "أدخل فئة المعاملة، مثل 'بيع' أو 'شراء' أو 'تحويل'.",
      customCategory: "فئة مخصصة",
      customCategoryDescription: "أدخل فئة مخصصة إذا كان مطبقًا. هذا للمعاملات التي لا تنتمي إلى الفئات المحددة مسبقًا.",
      city: "المدينة",
      cityDescription: "أدخل المدينة المتعلقة بالمعاملة.",
      state: "الولاية",
      stateDescription: "أدخل الولاية أو المنطقة التي حدثت فيها المعاملة.",
      postalCode: "الرمز البريدي",
      postalCodeDescription: "أدخل الرمز البريدي للموقع المرتبط بالمعاملة.",
      country: "البلد",
      countryDescription: "أدخل البلد الذي حدثت فيه المعاملة.",
      bestRepresentation: "أفضل تمثيل",
      bestRepresentationDescription: "أدخل أفضل تمثيل للمعاملة، والذي يمكن أن يكون وصفًا عامًا أو تصنيفًا.",
      runningBalanceAmountUSD: "مبلغ الرصيد الجاري (دولار أمريكي)",
      runningBalanceAmountUSDDescription: "أدخل مبلغ الرصيد الجاري بالدولار الأمريكي، وهو الرصيد المستمر بعد معالجة المعاملة.",
      subaccountSecurityType: "نوع أمان الحساب الفرعي",
      subaccountSecurityTypeDescription: "أدخل نوع الأمان المرتبط بالحساب الفرعي، إذا كان مطبقًا.",
      commissionAmountUSD: "مبلغ العمولة (دولار أمريكي)",
      commissionAmountUSDDescription: "أدخل مبلغ العمولة بالدولار الأمريكي، إذا كان مطبقًا. هذه هي الرسوم المفروضة على المعاملة.",
      tickerSymbol: "رمز المؤشر",
      tickerSymbolDescription: "أدخل رمز المؤشر للأصل أو الورقة المالية المتضمنة في المعاملة.",
      investmentTransactionType: "نوع معاملة الاستثمار",
      investmentTransactionTypeDescription: "أدخل نوع معاملة الاستثمار، مثل 'شراء' أو 'بيع' أو 'توزيعات أرباح'.",
      taxesAmountUSD: "مبلغ الضرائب (دولار أمريكي)",
      taxesAmountUSDDescription: "أدخل مبلغ الضرائب المتعلقة بالمعاملة، بالدولار الأمريكي.",
      currencySymbol: "رمز العملة",
      currencySymbolDescription: "أدخل رمز العملة المستخدمة في المعاملة، مثل '$' للدولار الأمريكي أو '€' لليورو.",
      incomeType: "نوع الدخل",
      incomeTypeDescription: "أدخل نوع الدخل، مثل 'راتب' أو 'فائدة' أو 'أرباح رأسمالية'.",
      splitDenominator: "مقام التقسيم",
      splitDenominatorDescription: "أدخل مقام أي معاملات كسرية أو مقسمة، إذا كان مطبقًا.",
      splitNumerator: "بسط التقسيم",
      splitNumeratorDescription: "أدخل بسط التقسيم إذا كان مطبقًا. هذه القيمة تستخدم للمعاملات التي تتضمن تقسيم المبالغ عبر فئات أو حسابات متعددة.",
      sharesPerContract: "الأسهم لكل عقد",
      sharesPerContractDescription: "أدخل عدد الأسهم لكل عقد إذا كان مطبقًا. هذا ذو صلة بمعاملات الاستثمار أو العقود التي تتضمن أسهمًا.",
      subAccountFund: "صندوق الحساب الفرعي",
      subAccountFundDescription: "أدخل صندوق الحساب الفرعي إذا كان مطبقًا.",
      securityId: "معرف الأمان",
      securityIdDescription: "أدخل معرف الأمان إذا كان مطبقًا.",
      securityIdType: "نوع معرف الأمان",
      securityIdTypeDescription: "أدخل نوع معرف الأمان إذا كان مطبقًا.",
      saveTransaction: "حفظ المعاملة"
    },
    multiActionText: {
      selectAll: 'تحديد الكل',
      deselectAll: 'إلغاء تحديد الكل',
      deleteSelected: 'حذف المحدد',
    },
    communicationResponse: {
      failedToLoad: 'فشل التحميل',
      emailError: 'تعذر جلب ردود البريد الإلكتروني. يرجى المحاولة مرة أخرى لاحقًا.',
      smsError: 'تعذر جلب ردود الرسائل النصية. يرجى المحاولة مرة أخرى لاحقًا.',
    },
    interactionHistory: {
      historyInteraction: "سجل التفاعل",
      lastContacted: "آخر تواصل",
      notesLastContacted: "ملاحظة",
      nextFollowUp: "المتابعة التالية",
      notesNextFollowUp: "ملاحظة",
      preferredContactTime: "وقت التواصل المفضل",
      preferredContactToTime: "إلى",
      notesContactToTime: "ملاحظة",
      noHistory: "لا يوجد سجل"
    },    
    imenuPayFlex:{
      invoiceId: "معرف الفاتورة",
      planName: "اسم الخطة",
      amount: "المبلغ",
      totalAmount: "المبلغ الإجمالي",
      subscription: "الاشتراك",
      schedulePayment: "جدول الدفع",
      recurringPayment: "دفع متكرر؟",
      frequency: "التكرار",
      payEvery: "ادفع كل",
      customInterval: "فترة مخصصة",
      customIntervalNote: "سيتم الدفع كل {days} يوم",
      payStartsOn: "يبدأ الدفع في",
      payUntil: "الدفع حتى",
      endsAfterDate: "ينتهي الدفع بعد التاريخ",
      endsAfterOccurrences: "ينتهي الدفع بعد {count} مرات",
      howToPay: "كيف تريد الدفع؟",
      creditCard: "بطاقة ائتمان",
      banking: "الخدمات المصرفية",
      placeholderCustomInterval: "2",
      placeholderOccurrences: "مثال: 2",
    },
    googleCalendar: {
      createEvent: "إنشاء حدث",
      title: "العنوان",
      description: "الوصف",
      location: "الموقع",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      timeZone: "المنطقة الزمنية",
      selectTimeZone: "اختر المنطقة الزمنية",
      attendeeEmail: "بريد الحضور",
      attendeeEmailPlaceholder: "client@example.com",
      attendeeEmailLabel: "بريد الحضور",
      addAttendee: "إضافة حضور",
      providerEmail: "بريد الموفر",
      providerEmailPlaceholder: "provider@example.com",
      color: "اللون",
      selectColor: "اختر لونًا",
      submitEvent: "إنشاء الحدث",
      updateEvent: "تحديث الحدث",
      upcomingEvents: "الأحداث القادمة",
      deleteConfirmationTitle: "هل أنت متأكد؟",
      deleteConfirmationText: "لن تتمكن من التراجع عن هذا!",
      deleteNotificationCheckbox: "هل تريد إعلامهم بإلغاء الحدث؟",
      deleteConfirmButton: "نعم، احذفه!",
      deleteCancelButton: "إلغاء",
      deleteSuccessTitle: "تم الحذف!",
      deleteSuccessText: "تم حذف الحدث بنجاح.",
      deleteErrorTitle: "خطأ!",
      deleteErrorText: "تعذر حذف الحدث."
    },        
    bulkSend: {
      title: "ما هو الإرسال الجماعي؟",
      text: "يسمح لك الإرسال الجماعي بإرسال رسائل بريد إلكتروني ورسائل نصية متعددة دفعة واحدة، مما يجعل التواصل أكثر كفاءة.",
      confirmButtonText: "فهمت!",
      selectRecipientsTitle: "اختر المستلمين",
      selectAllCustomers: "اختر جميع العملاء",
      selectAllSubscribers: "اختر جميع المشتركين",
      bulkSendOptionsTitle: "خيارات الإرسال الجماعي",
      sendEmail: "إرسال بريد إلكتروني جماعي",
      sendSMS: "إرسال رسائل نصية جماعية",
      whenToSend: "متى تريد الإرسال؟",
      sendNow: "إرسال الآن",
      schedule: "جدولة",
      cancel: "إلغاء",
      validationSelectMethod: "الرجاء اختيار طريقة واحدة على الأقل.",
      validationScheduledTime: "يجب أن يكون الوقت المجدول في المستقبل.",
      successSent: "تم الإرسال بنجاح!",
      successScheduled: "تم الجدولة بنجاح!",
      error: "حدث خطأ.",
      subject: "إشعار جماعي",
      body: "محتوى الرسالة المجدولة هنا.",
      bulkSend:"إرسال جماعي",
      validationSelectRecipients: "اختر مستلمًا واحدًا على الأقل"
    },      
    table: {
      transactionDate: 'تاريخ المعاملة',
      customerId: 'معرف العميل',
      status: 'الحالة',
      debit: 'مدين',
      credit: 'دائن',
      description: 'الوصف',
      memo: 'مذكرة',
      payee: 'المستفيد',
      category: 'الفئة',
      bestRepresentation: 'أفضل تمثيل',
      country: 'البلد',
      action: 'إجراء'
    },
    emailTest: {
      sendTest: 'إرسال بريد إلكتروني تجريبي',
      message: "هذه رسالة نموذجية. يرجى عدم الرد على هذه الرسالة.",
      subject: 'دعم iMenuApps®.',
      success: 'تم إرسال البريد الإلكتروني بنجاح.'
    },
    menu: {
      transactionData: 'بيانات المعاملة',
      bankAccountConnection: 'اتصال الحساب البنكي',
      viewTransactions: 'عرض المعاملات',
      validationPhone: 'يجب أن يحتوي رقم الهاتف على 10 أرقام بالضبط.',
      savedSuccesful: 'تم تغيير الإعداد بنجاح',
      savedFailed: 'حدث خطأ في حفظ الإعدادات.',
      lostChanges: 'سيتم فقدان التغييرات إذا غادرت هذه الصفحة!',
      sure: 'هل أنت متأكد؟',
      wontRevert: "لن تتمكن من التراجع عن هذا!",
      yesVoid: 'نعم، إبطال الدفع!',
      voided: 'تم الإبطال!',
      voidedSuccessfully: 'تم إبطال الدفع بنجاح.',
      yesRefund: 'نعم، استرداد!',
      refund: 'تم الاسترداد!',
      refundSuccessfully: 'تمت معالجة الاسترداد بنجاح.',
      merchantQuoteNotes: 'ملاحظات عروض الأسعار للتاجر',
      merchantInvoiceNotes: 'ملاحظات الفواتير للتاجر',
      titleInformationIncomplete: 'معلومات مطلوبة',
      informationIncomplete: 'الرجاء إكمال جميع الحقول المطلوبة.',
      yes: 'نعم',
      emailSend: 'تم إرسال البريد الإلكتروني',
      emailSendTo: 'تم إرسال البريد الإلكتروني مع الفاتورة بنجاح إلى',
      questionSendEmail: 'إرسال بريد إلكتروني؟',
      dialogSendEmail: 'هل أنت متأكد أنك تريد إرسال البريد الإلكتروني إلى',
      addNewSendEmail: 'إضافة عنوان بريد إلكتروني آخر',
      send: 'إرسال',
      close: 'إغلاق',
      alertEmailSend: 'تم إرسال البريد الإلكتروني',
      alertEmailSendTo: 'تم الإرسال بنجاح إلى',
      session: 'الجلسة',
      foodServices: 'المنتجات/الخدمات',
      ordersTickets: 'الطلبات/التذاكر',
      reservationsDeliveries: 'الحجوزات/التوصيلات',
      restaurantAdministration: 'الإدارة',
      report: 'التقارير',
      sales: 'المبيعات',
      staffOccupationsCustomersDrivers: 'الموظفون/المهن/العملاء/السائقون',
      marketing: 'التسويق',
      settings: 'الإعدادات',
      merchantSettings: 'إعدادات التاجر',
      revenue: 'الإيرادات',
      revenueInfo: 'قسم الإيرادات في iMenuApps® هو مركزك المركزي لإدارة جميع الأنشطة المدرة للدخل داخل عملك. يسمح لك هذا القسم بإدارة المهام المختلفة المتعلقة بالإيرادات والمعاملات المالية بكفاءة، مما يضمن أن عمليات عملك سلسة ومربحة. إليك ما يمكنك القيام به في قسم الإيرادات: 1. عرض/إنشاء الطلبات: إدارة طلبات العملاء من الإنشاء إلى الانتهاء. تتيح لك هذه الميزة تتبع جميع الطلبات، مما يضمن معالجتها 2. الحجوزات: إدارة وتتبع الحجوزات لخدماتك، سواء لتناول الطعام أو الفعاليات أو الحجوزات الأخرى. تضمن هذه الميزة أنك تستطيع إدارة حجوزاتك بفعالية وتجنب الحجز الزائد. 3. عروض الأسعار: إنشاء وإدارة عروض الأسعار للإيرادات المحتملة، مما يسمح لك بتزويد العملاء بتسعير مفصل ومعلومات الخدمة قبل إتمام البيع. يمكنك بسهولة تحويل عروض الأسعار المقبولة إلى فواتير لتبسيط عملية الإيرادات. 4. الفواتير: إنشاء وإدارة وتتبع جميع فواتير العملاء. تضمن هذه الميزة الفوترة الدقيقة وتوفر سجلاً واضحًا لجميع معاملات الإيرادات. 5. الشحن: تنسيق وإدارة تفاصيل الشحن للطلبات، بما في ذلك التحضير والجدولة وإرسال الشحنات. 6. تتبع الشحنات: مراقبة حالة وتقدم الشحنات في الوقت الفعلي، مما يضمن أن توصيلاتك في الموعد المحدد ويتم إعلام العملاء. 7. فوترة الاشتراكات: إدارة الفوترة المتكررة لخدمات الاشتراك، مما يضمن فوترة العملاء بدقة وفي الوقت المحدد للخدمات المستمرة. 8. التوصيلات: الإشراف وإدارة جميع أنشطة التوصيل، من تنفيذ الطلب إلى التوصيل النهائي للعملاء، مما يضمن وصول السلع والخدمات إلى وجهتها بكفاءة. 9. طلبات الاستلام: معالجة طلبات العملاء لاستلام الطلبات، مما يسمح لهم باستلام طلباتهم مباشرة من موقع عملك.',
      adminInfo: 'قسم الإدارة في iMenuApps® بمثابة مركز التحكم لإدارة الجوانب التشغيلية واللوجستية المختلفة لعملك. إليك نظرة عامة على الميزات والمهام التي يمكنك إدارتها داخل هذا القسم: 1. إدارة الجداول: • تكوين وإدارة إعداد الجداول في عملك، بما في ذلك عدد الجداول وترتيبها وسعة الجلوس. • تحسين المساحة للحجوزات وضمان دوران فعال للجداول. 2. إدارة الضرائب: • تعيين وإدارة معدلات الضرائب المطبقة على العناصر والخدمات المحددة. • ضمان تطبيق الضرائب بدقة على جميع المعاملات وفقًا للوائح المحلية. 3. إدارة التوصيل: • الإشراف على عمليات التوصيل من التخصيص إلى الانتهاء. • تتبع الطلبات في الوقت الفعلي وتزويد العملاء بتحديثات حول توصيلاتهم. • ضمان خدمات توصيل فعالة وفي الوقت المحدد لتعزيز رضا العملاء. 4. إدارة الموظفين: • إدارة فريق الموظفين، بما في ذلك إضافة موظفين جدد وتحديث الأدوار وإدارة الأذونات. • إعداد الأدور وتخصيص المهام لضمان عمليات سلسة. 5. إدارة السائقين: • إدارة سائقي التوصيل، تعيين مهام التوصيل وتتبع أدائهم. • ضمان أن خدمة التوصيل تعمل بسلاسة وكفاءة. 6. أدوار الأذونات: • تحديد وإدارة الأدوار والأذونات للموظفين والمسؤولين. • ضمان أن كل عضو في الفريق لديه إمكانية الوصول إلى الأدوات والمعلومات التي يحتاجها لأداء واجباته بفعالية. 7. إدارة أوراق العمل: • تتبع وإدارة ساعات العمل وجداول الموظفين. • ضمان حفظ الوقت بدقة ومعالجة الرواتب. 8. إدارة المهن: • تنظيم وإدارة المهن المختلفة للموظفين داخل عملك. • الحفاظ على هيكل الفريق وتحديد الأدوار بوضوح. 9. إدارة العملاء: • إدارة معلومات العملاء، تتبع الطلبات والحفاظ على ملفات العملاء. • تعزيز خدمة العملاء من خلال جعل جميع تفاصيل العملاء سهلة الوصول. 10. إدارة الاعتمادات: • معالجة اعتمادات العملاء بكفاءة، تطبيق الاعتمادات على الطلبات وتتبع أرصدة الاعتمادات. 11. إدارة الاختيارات: • تصميم وإدارة اختيارات عملك، بما في ذلك إنشاء اختيارات جديدة وتحديث العناصر وإدارة التسعير. 12. إدارة الفئات: • تنظيم عناصر الاختيارات في فئات لتسهيل التصفح والإدارة. • الحفاظ على هيكل الاختيارات وسهولة تصفحها للعملاء. 13. إدارة المنتجات: • إدارة مخزون المنتجات، بما في ذلك إضافة عناصر جديدة وتحديث العناصر الحالية وإدارة مستويات المخزون. 14. مولد الباركود: • إنشاء وإدارة الباركود لمنتجاتك لتبسيط إدارة المخزون وتتبع الإيرادات. 15. إدارة الخدمات: • إدارة الخدمات الإضافية التي تقدمها مطعمك، مثل التموين أو استضافة الفعاليات. • تتبع حجوزات الخدمات وضمان عمليات سلسة. 16. رسوم أخرى: • إعداد وإدارة رسوم إضافية مثل رسوم الخدمة أو رسوم التوصيل أو رسوم الفعاليات الخاصة. • ضمان أن جميع الرسوم المطبقة تنعكس بدقة في فواتير العملاء. 17. أسعار خاصة: • إدارة وتطبيق تسعير خاص للترقيات أو الخصومات أو برامج الولاء. • تقديم تسعير تنافسي لجذب العملاء والاحتفاظ بهم. 18. إدارة المشتركين: • إدارة قائمة مشتركي العملاء للنشرات الإخبارية والترقيات. 19. التسويق الإلكتروني: • تخطيط وتنفيذ حملات التسويق عبر البريد الإلكتروني والرسائل النصية. • استخدام بيانات العملاء لاستهداف جماهير محددة وجذب المزيد من الأعمال إلى مطعمك. يوفر لك هذا القسم جميع الأدوات التي تحتاجها لإدارة عمليات عملك بكفاءة، من الموظفين والعملاء إلى الاختيارات والتسويق، كل ذلك في مكان واحد.',
      imenuBookInfo: 'قسم iMenuBooks هو مركزك الشامل لإدارة الحسابات والمالية. تتيح لك هذه المنطقة إدارة المعاملات بسلاسة، والاتصال بالحسابات المصرفية، والحفاظ على سجل واضح ودقيق للأنشطة المالية. إليك ما يمكنك القيام به في قسم iMenuBooks: 1. بيانات المعاملات: إدارة وتخزين جميع بيانات المعاملات المتعلقة بعملك. تتيح لك هذه الميزة تتبع كل معاملة مالية، مما يضمن أن سجلاتك دقيقة وحديثة. 2. اتصال الحساب المصرفي: قم بتوصيل حساباتك المصرفية التجارية مباشرة بنظام iMenuBooks. تتيح لك هذه الميزة مزامنة البيانات المالية تلقائيًا، مما يجعل إدارة الدخل والمصروفات وأرصدة الحسابات أسهل. 3. عرض المعاملات: عرض سجلات مفصلة لجميع المعاملات المالية المعالجة من خلال عملك. توفر هذه الميزة عرضًا منظمًا وقابلًا للبحث لسجل المعاملات الخاص بك، مما يسمح لك بمراقبة ومراجعة الأنشطة المالية بسهولة.',
      reportsInfo: 'قسم التقارير هو مركزك المركزي للوصول إلى بيانات أداء ومالية عملك وتحليلها. يوفر لك هذا القسم أدوات وتقارير مختلفة لمساعدتك في اتخاذ قرارات مستنيرة بناءً على البيانات في الوقت الفعلي. إليك ما يمكنك القيام به في قسم التقارير: 1. المدفوعات: تتبع ومراجعة جميع المدفوعات التي قام بها العملاء. توفر هذه الميزة تفصيلاً للمعاملات المالية، مما يساعدك على مراقبة الدخل وضمان سجلات مالية دقيقة. 2. حساب المنزل: إدارة ومراجعة حسابات المنزل المستخدمة من قبل عملائك الدائمين. تتيح لك هذه الميزة تتبع أرصدة الحسابات والرسوم والمدفوعات، مما يضمن أن حسابات المنزل محدثة دائمًا. 3. الإيرادات حسب العملاء: تحليل بيانات الإيرادات المجزأة حسب العملاء الأفراد. يساعدك هذا التقرير في تحديد العملاء الرئيسيين وفهم سلوكياتهم الشرائية، مما يسمح بالتسويق المستهدف وتحسين علاقات العملاء. 4. الإيرادات حسب المنتجات: عرض بيانات الإيرادات بناءً على منتجات محددة. يتيح لك هذا التقرير تحديد العناصر الأكثر مبيعًا وفهم أداء المنتج، مما يساعد في إدارة المخزون واتخاذ قرارات تطوير المنتج. 5. تقرير ديناميكي: إنشاء تقارير مخصصة مصممة خصيصًا لاحتياجات عملك المحددة. تتيح لك هذه الميزة إنشاء تقارير ديناميكية عن طريق تحديد معايير مختلفة، مما يمنحك المرونة لتحليل بياناتك من وجهات نظر متعددة.',
      configInfo: 'يسمح لك قسم إعدادات التاجر بتكوين جوانب أساسية مختلفة من عمليات عملك، مما يضمن أن النظام يتوافق مع متطلباتك وتفضيلاتك الفريدة. يتضمن هذا القسم المجالات الرئيسية التالية: 1. الإعدادات العامة: • معلومات العمل: إعداد وتحديث وجود عملك على الإنترنت، بما في ذلك الاسم والعنوان وتفاصيل الاتصال وروابط وسائل التواصل الاجتماعي وعملة المطعم. • التواجد على الإنترنت: إدارة عنوان URL لموقعك الإلكتروني والموقع وتفاصيل الفاكس. هذا أمر بالغ الأهمية لضمان أن العملاء يمكنهم العثور عليك والاتصال بك بسهولة. • ساعات العمل: تعيين وتحديث ساعات عملك، مما يضمن أن عملائك يعرفون متى تكون متاحًا. • الشروط والسياسات: تحرير وإدارة شروط الاستخدام وسياسة الخصوصية والسياسات الأخرى ذات الصلة بسهولة لضمان الامتثال والشفافية مع عملائك. • إعدادات التموين والتوصيل: تحديد حالات التموين والرموز البريدية المطبقة وأنواع فعاليات التموين. بالإضافة إلى ذلك، إدارة مناطق التوصيل وتبديل ميزات مثل رسوم التوصيل وعرض الموقع الجغرافي ومدى إظهار التقييمات. • التجارة الإلكترونية والمبيعات عبر الإنترنت: التحكم في ميزات مثل فواتير الرسوم المتأخرة وطلبات استلام الأصول والودائع، مما يضمن معاملات عبر الإنترنت سلسة وإدارة الطلبات. 2. الوظائف: تكوين وظائف محددة لطلبات التموين والحجوزات، بما في ذلك تفضيلات موقع الجدول وعروض حجز العملاء وخيارات الدفع المسبق والإعدادات المستندة إلى الوقت. • إعدادات الفاتورة وعرض الأسعار: تكوين أرقام البداية وبادئات الفواتير وعروض الأسعار الخاصة بك، مما يساعدك في الحفاظ على نظام فوترة منظم واحترافي. • إدارة الطلبات: إعداد وإدارة بادئات الطلبات وأوقات الاستلام وتكوينات أخرى متعلقة بالطلبات لتبسيط معالجة الطلبات. • تكوين الإكراميات: إدارة متطلبات الإكراميات، بما في ذلك تعيين نسب الإكراميات الافتراضية، وهو أمر مفيد بشكل خاص في صناعات الخدمات. • إعدادات الرؤية: التحكم في ما إذا كانت بعض المعلومات أو الميزات مرئية لعملائك، مثل ما إذا كنت تريد عرض الطباخ أو الشركات الأخرى. 3. إعدادات التصميم: • نظام الألوان: تخصيص نظام الألوان لتطبيقك، بما في ذلك الألوان الأساسية والثانوية والثالثية، لتتوافق مع هوية علامتك التجارية. قم بتخصيص الجوانب المرئية لمنصتك عن طريق ضبط الألوان الأساسية والثانوية والثالثية، وتخصيص اللافتات الرقمية، وإدارة شرائح "من نحن" لعرض عملك بطريقة جذابة. • شرائح "من نحن": إدارة الشرائح التي تظهر في قسم "من نحن"، مما يسمح لك بعرض العروض الفريدة وشخصية عملك. • اللافتات الرقمية: إعداد لافتات رقمية لعرض المعلومات الرئيسية والاختيارات والإعلانات داخل تطبيقك أو في موقعك الفعلي. 4. النسخ الاحتياطي وإدارة الأجهزة: • إدارة الأجهزة: إضافة وإدارة الأجهزة المتصلة بنظامك، مثل أنظمة نقاط البيع والطابعات والمزيد، مما يضمن أن كل شيء متزامن ويعمل بشكل صحيح. • خيارات النسخ الاحتياطي: إنشاء نسخ احتياطية من بياناتك وإعداداتك لضمان وجود نسخة احتياطية في حالة أي مشكلات فنية. يمكنك تنزيل النسخ الاحتياطية أو الاستعادة من البوابة أو الاستعادة من ملف. ضمان سلامة البيانات عن طريق عمل نسخ احتياطية والاستعادة من الملفات وإدارة الأجهزة المتصلة مثل محطات الدفع. تتيح لك هذه الإعدادات تخصيص تجربة iMenuApps® وفقًا لاحتياجات عملك، مما يجعل إدارة العمليات أسهل والحفاظ على وجود علامة تجارية متسقة عبر جميع نقاط اتصال العملاء.',
      selections: 'الاختيارات',
      productManagement: 'إدارة المنتجات'
    },
    controlPanel: {
      googleCalendar: 'تقويم جوجل',
      notificationCenter: 'مركز الإشعارات',
      notificationBell: 'جرس الإشعارات',
      salesByCustomers: 'المبيعات حسب العملاء',
      salesByProducts: 'المبيعات حسب المنتجات',
      dynamicReport: 'تقرير ديناميكي',
      events: "إنشاء أحداث",
      eventTitle: "الأحداث",
      transactionData: 'إضافة وتحرير المعاملات المالية',
      bankConnect: 'إضافة حسابات بنكية وحسابات بطاقات ائتمان',
      viewTransaction: 'إضافة / تحرير / عرض / معاملاتك',
      subscription: 'عرض وإنشاء الاشتراكات والفوترة (المحطة الافتراضية)',
      staff: 'إنشاء حسابات مستخدمين لعمال الأعمال.',
      occupations: 'إدارة مهن الأعمال. ترتبط المهن بأعضاء الموظفين. لكل عضو مهنة محددة.',
      roles: 'إدارة الأدوار. تحدد الأدوار الأذونات في مناطق مختلفة من التطبيق وترتبط بأعضاء الموظفين. يمكن أن يكون لعضو الموظف أدوار متعددة.',
      workSheet: 'ورقة العمل. تسمح أوراق العمل بالتحكم في وقت عمل الموظفين.',
      customers: 'يعرض قائمة بعملاء الأعمال.',
      categories: 'إدارة الفئات المختلفة للقوائم. ترتبط الفئات بالعناصر. ينتمي العنصر إلى فئة.',
      menuItems: 'إدارة العناصر/المنتجات/الخدمات. تتكون القائمة من فئات، وبدورها، ترتبط العناصر/المنتجات/الخدمات بالقائمة من خلال الفئة التي تنتمي إليها.',
      services: 'إدارة الخدمات. تستخدم الخدمات في قوائم التموين.',
      menus: 'إدارة القوائم. تسمح بإدارة القوائم. تتكون القائمة من فئات مختلفة.',
      orders: 'عرض وإنشاء الطلبات. يمكنك عرض وإنشاء الطلبات هنا',
      invoices: 'عرض وإنشاء الفواتير. يمكنك عرض وإنشاء الفواتير هنا',
      quotes: 'عرض وإنشاء عروض الأسعار. يمكنك عرض وإنشاء عروض الأسعار هنا',
      cateringOrders: 'يسمح بعرض طلبات التموين.',
      orderForDelivery: 'يعرض قائمة بالطلبات الجاهزة للتسليم إلى السائق الذي تم تعيين الطلب له.',
      tickets: 'يسمح بإنشاء وتتبع التذاكر. التذاكر هي طلبات تظل مفتوحة بينما يستمر العميل في الاستهلاك.',
      otherCharges: 'يسمح بإدارة رسوم إضافية لكمية المنتجات.',
      taxes: 'إدارة الضرائب. عرض وإنشاء معدلات ضريبة المبيعات',
      deliveries: 'إدارة أسعار التوصيل. عرض وإنشاء سعر التوصيل لتحصيله من العميل',
      reservations: 'إدارة وإنشاء الحجوزات وقوائم الانتظار',
      tables: 'إدارة سعات الأعمال. عرض وإنشاء الحجوزات بناءً على سعة الأعمال',
      payments: 'يعرض قائمة بمعاملات الدفع التي تم إجراؤها.',
      aboutSettings: 'يسمح بإدارة الشريط الذي يظهر على الصفحة الرئيسية لكل عمل.',
      paymentSettings: 'يسمح بتكوين بوابة الدفع التي سيتم استخدامها لمعالجة المعاملات.',
      basicSettings: 'يسمح بتكوين البيانات الرئيسية للأعمال: الاسم، العنوان، الهاتف... تظهر هذه المعلومات على الصفحة الرئيسية لكل عمل.',
      funtionalitiesSettings: 'يسمح بتكوين التشغيل العام للأعمال: الساعات، الرموز البريدية، الإكراميات...',
      colorSettings: 'يسمح بتكوين ألوان التطبيق.',
      systemSettings: 'يسمح بتكوين تكامل iMenuApps® مع تطبيقات الطرف الثالث.',
      driver: 'إدارة السائقين الخارجيين',
      credit: 'السماح بإدارة الاعتمادات.'
    },
    options: {
      sameAsBilling: 'مطابق للفوترة',
      contactPerson: 'شخص الاتصال',
      email: 'البريد الإلكتروني',
      aditionalDetails: 'تفاصيل إضافية',
      street: 'الشارع',
      text: 'كانت هناك مشكلة في تعيين العنوان الافتراضي.',
      updateAddress: 'تم تحديث العنوان',
      wrongAddress: 'حدث خطأ أثناء محاولة تحديث العنوان الافتراضي',
      billingAddress: 'عنوان الفوترة',
      shippingAddress: 'عنوان الشحن',
      placeholderNotes: 'اكتب ملاحظاتك هنا',
      dataRequired: 'بيانات مطلوبة',
      customerArea: 'منطقة العميل',
      customerName: 'اسم العميل',
      customerEmail: 'بريد العميل الإلكتروني',
      customerPhone: 'هاتف العميل',
      customerAddress: 'عنوان العميل',
      terms: 'الشروط',
      trackingN: 'رقم التتبع',
      shippingDate: 'تاريخ الشحن',
      shippingTo: 'الشحن إلى',
      footer: 'تحرير التذييل المناسب لوحدة الإيرادات الخاصة بك',
      ivoiceDate: 'تاريخ الفاتورة',
      quoteDate: 'تاريخ عرض السعر',
      subscriptionBilling: 'فوترة الاشتراك',
      driverDeliveries: 'التوصيلات',
      activeDriverOrder: 'الطلبات النشطة',
      completedDriverOrder: 'الطلبات المكتملة',
      useDirection: 'انقر إذا كان مطابقًا لعنوان الفوترة',
      menuTitle: 'المشرف',
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      controlPanel: 'لوحة التحكم',
      adminSettings: 'إعدادات المسؤول',
      supportPanel: 'الدعم',
      manageMenus: 'القوائم',
      managePyments: 'المدفوعات',
      manageHouseAccount: 'حساب المنزل',
      viewOrders: 'عرض/إنشاء الطلبات',
      viewQuotes: 'عروض الأسعار',
      viewInvoice: 'الفواتير',
      manageCategories: 'الفئات',
      manageProducts: 'العناصر',
      manageServices: 'الخدمات',
      manageCustomers: 'العملاء',
      manageCredits: 'الاعتمادات',
      manageTables: 'الجداول',
      manageTaxes: 'الضرائب',
      manageShippings: 'أسعار التوصيل',
      manageOtherCharges: 'رسوم أخرى',
      manageUsers: 'الموظفون',
      manageDriver: 'السائقون',
      manageRoles: 'الأدوار/الأذونات',
      manageWorkSheet: 'ورقة العمل',
      manageBasicSettings: 'الأعمال',
      manageRestaurantSettings: 'إعدادات الأعمال',
      manageAboutSettings: 'شرائح من نحن',
      manageFunSettings: 'الوظائف',
      manageColourSettings: 'الألوان',
      manageDesign: 'التصميم',
      manageMore: 'المزيد',
      managePaymentSettings: 'المدفوعات',
      manageOccupation: 'المهن',
      manageKeySettings: 'الأنظمة الخارجية',
      supportSettings: 'إعدادات الدعم',
      changeServerId: 'تغيير رمز الموظف',
      serverId: 'رمز الموظف',
      manageVariantGroup: 'الاختيارات',
      manageReservation: 'الحجوزات',
      manageWaitList: 'قائمة الانتظار',
      viewCateringOrders: 'طلبات التموين',
      forgotPassword: 'هل نسيت كلمة المرور؟',
      sendNewPassword: 'إرسال كلمة مرور جديدة',
      serverIdMessage: 'هذا هو رمز الأمان المخصص لك عند إنشاء ملفك الشخصي',
      recoveryPassword: 'استعادة كلمة المرور',
      refund: 'استرداد',
      void: 'إبطال'
    },
    titles: {
      technology: "التكنولوجيا",
      retail: "التجزئة",
      healthcare: "الرعاية الصحية",
      finance: "التمويل",
      retailGeneralMerchandise: "التجزئة (البضائع العامة)",
      healthcareServices: "خدمات الرعاية الصحية",
      foodAndBeverage: "الطعام والمشروبات (مطاعم، مقاهي، حانات)",
      construction: "البناء",
      eCommerce: "التجارة الإلكترونية",
      informationTechnology: "تكنولوجيا المعلومات (خدمات تكنولوجيا المعلومات وتطوير البرمجيات)",
      realEstate: "العقارات (سكنية وتجارية)",
      transportationLogistics: "النقل والخدمات اللوجستية",
      professionalServices: "الخدمات المهنية (استشارات، قانونية، محاسبة)",
      manufacturing: "التصنيع (عام ومتخصص)",
      educationTraining: "خدمات التعليم والتدريب",
      entertainmentMedia: "الترفيه والإعلام",
      financialServices: "الخدمات المالية (بنوك، شركات استثمار)",
      personalCareServices: "خدمات العناية الشخصية (صالونات، منتجعات صحية)",
      hospitality: "الضيافة (فنادق، وكالات سفر)",
      insuranceAgencies: "وكالات التأمين",
      homeImprovementRepair: "تحسين المنزل والإصلاح",
      automotiveServices: "خدمات السيارات (إصلاح، وكالات، محلات تصليح)",
      telecommunications: "الاتصالات",
      nonprofitSocialServices: "غير الربحية والخدمات الاجتماعية",
      agricultureFarming: "الزراعة والمزارع",
      pharmaceuticalsBiotechnology: "الأدوية والتكنولوجيا الحيوية",
      energy: "الطاقة (متجددة وغير متجددة)",
      sportsRecreation: "الرياضة والترفيه",
      fitnessWellness: "اللياقة والعافية",
      marketingAdvertising: "التسويق والإعلان",
      eventPlanning: "تخطيط الفعاليات والخدمات",
      cleaningServices: "خدمات التنظيف (سكنية وتجارية)",
      fashionApparel: "الموضة والملابس",
      foodProductionProcessing: "إنتاج وتجهيز الأغذية",
      petServices: "خدمات الحيوانات الأليفة (تجميل، إيواء، بيطرية)",
      artsCrafts: "الفنون والحرف اليدوية (خدمات إبداعية)",
      aerospaceDefense: "الفضاء والدفاع",
      environmentalServices: "الخدمات البيئية",
      technologyHardwareElectronics: "أجهزة التكنولوجيا والإلكترونيات",
      childcareServices: "خدمات رعاية الأطفال",
      securityServices: "خدمات الأمن (الأمن السيبراني، الأمن المادي)",
      publishing: "النشر (كتب، مجلات، وسائط رقمية)",
      transportationEquipmentManufacturing: "تصنيع معدات النقل",
      architectureDesign: "العمارة والتصميم",
      accountingTaxPreparation: "المحاسبة وإعداد الضرائب",
      landscapingGardening: "تنسيق الحدائق والبستنة",
      beverageProduction: "إنتاج المشروبات (بيرة حرفية، نبيذ، مشروبات روحية)",
      medicalDevicesSupplies: "الأجهزة والمستلزمات الطبية",
      warehousingStorage: "التخزين والمستودعات",
      freelancing: "العمل الحر (كتابة، تصميم جرافيك، برمجة)",
      tourismAdventureServices: "السياحة وخدمات المغامرات",
      utilitiesPublicServices: "المرافق والخدمات العامة",
      blockchainCryptocurrency: "بلوك تشين والعملات المشفرة",
      specializedRetail: "التجزئة المتخصصة (منتجات وخدمات متخصصة)",
      eventPlanningServices: "تخطيط الفعاليات والخدمات",
      transportationEquipment: "تصنيع معدات النقل",
      accountingTax: "المحاسبة وإعداد الضرائب",
      tourismAdventure: "السياحة وخدمات المغامرات",
      shareViaEmailAndSMS: 'مشاركة عبر البريد الإلكتروني والرسائل النصية',
      sendEmail: 'إرسال بريد إلكتروني',
      sendSMS: 'إرسال رسالة نصية',
      send: "إرسال",
      sendNow: 'إرسال الآن',
      schedule: 'جدولة',
      cancel: 'إلغاء',
      searchCustomer: 'البحث عن عميل أو مشترك',
      emailPlaceholder: 'البريد الإلكتروني',
      phonePlaceholder: 'رقم الهاتف',
      sendByEmailAndSMS: 'إرسال عبر البريد الإلكتروني والرسائل النصية',
      textSend: 'يمكنك إضافة عناوين بريد إلكتروني متعددة عن طريق إضافة فاصلة بعد كل عنوان',
      sendNotification: 'أنت على وشك إرسال هذا الإشعار إلى:',
      whenToSend: 'متى تريد الإرسال؟',
      bankAccountName: 'اسم الحساب البنكي',
      routeNumber: 'رقم المسار',
      accountNumber: 'رقم الحساب',
      bankAccountAddress: 'عنوان الحساب البنكي',
      nameAuthorizedPerson: 'اسم الشخص المصرح له',
      paymentAmount: 'مبلغ الدفع',
      mustBe: 'يجب أن يكون 9 أرقام',
      warning: 'تحذير',
      messageChangeQuote: 'إذا قمت بتغيير هذه البادئة مرة أخرى، سيتغير تسلسل ترقيم عروض الأسعار الخاصة بك',
      messageChangeIvoice: 'إذا قمت بتغيير هذه البادئة مرة أخرى، سيتغير تسلسل ترقيم فواتيرك',
      messageStartingInvoiceNumber: 'إذا قمت بتغيير رقم البداية هذا، سيتم إعادة تعيين ترقيم الفواتير لتبدأ من هذا الرقم.',
      prefixQuotes: 'بادئة لعروض الأسعار (مثال: QTE)',
      prefixInvoices: 'بادئة للفواتير (مثال: INV)',
      invoiceStartingNumber: 'رقم بداية الفاتورة',
      moneyNotEnought: 'يجب أن يكون المبلغ أكبر من الإجمالي للحصول على التغيير',
      controlPanel: 'لوحة التحكم',
      supportPanel: 'الدعم',
      menus: 'القوائم',
      orders: 'الطلبات',
      quotes: 'عروض الأسعار',
      invoices: 'الفواتير',
      allOrders: 'جميع الطلبات',
      customerCredit: 'ائتمان العميل',
      workSheet: 'ورقة العمل',
      cateringOrders: 'طلبات التموين',
      ordersForDelivery: 'طلبات للتوصيل',
      suscriptors: 'المشتركون',
      tickets: 'تذاكر الطلبات',
      categories: 'الفئات',
      products: 'العناصر',
      customers: 'العملاء',
      tables: 'الجداول',
      taxes: 'الضرائب',
      shippings: 'أسعار التوصيل',
      otherCharges: 'رسوم أخرى',
      newsletter: 'النشرة الإخبارية',
      users: 'الموظفون',
      suscriptor: 'المشتركون',
      createCustomer:"إنشاء عميل",
      communicationResponse: 'ردود الاتصالات',
      smsResposes: "ردود الرسائل النصية",
      emailResponses: "ردود البريد الإلكتروني",
      loadingEmailResponses: "جارٍ تحميل ردود البريد الإلكتروني...",
      loadingSmsResponses: "جارٍ تحميل ردود الرسائل النصية...",
      perPage: "لكل صفحة",
      emailNoSent: "بريد إلكتروني غير مرسل",
      noEmailResponses: "لا توجد ردود بريد إلكتروني",
      noEmailFound: "لم يتم العثور على ردود بريد إلكتروني لحسابك",
      noSmsResponses: "لا توجد ردود رسائل نصية",
      noSmsFound: "لم يتم العثور على ردود رسائل نصية لحسابك",
      createSubscriptor: "إنشاء مشترك",
      occupation: 'المهنة',
      roles: 'الأدوار',
      about: 'شرائح من نحن',
      digitalScreens: 'شاشات رقمية',
      editAboutForm: 'تحرير شريحة من نحن',
      newAboutForm: 'إنشاء شريحة من نحن جديدة',
      editDisplayForm: 'تحرير شريحة لافتة رقمية',
      newDisplayForm: 'إنشاء شريحة لافتة رقمية',
      basicConfig: 'التكوين الأساسي',
      functions: 'الوظائف',
      colors: 'الألوان',
      variantGroup: 'الاختيارات',
      loading: 'يرجى الانتظار...',
      editColorSetting: 'تحرير اللون',
      createColorSetting: 'إنشاء لون',
      orderCateringForm: 'تحرير طلب التموين',
      deliveryLocation: 'موقع التوصيل',
      cateringMenus: 'قوائم التموين',
      payments: 'المدفوعات',
      ticketDetails: 'تفاصيل التذكرة',
      emptyResult: 'نتيجة فارغة',
      cancellationType: 'نوع الإلغاء',
      changePassword: 'تغيير كلمة المرور',
      restaurantName: 'اسم العمل',
      clockinClockout: 'تسجيل الدخول - تسجيل الخروج',
      clockin: 'تسجيل الدخول',
      clockout: 'تسجيل الخروج',
      timecard: 'البطاقة الزمنية',
      timesheet: 'جدول الوقت',
      addContact: 'إضافة جهة اتصال',
      updateContact: 'تحديث جهة اتصال',
      contacts: 'جهات الاتصال',
      staff: 'الموظفون'
    },
    placeholder: {
      contactNotFound: 'جهة الاتصال غير موجودة'
    },
    orderState: {
      started: 'تم البدء',
      inKitchen: 'في المطبخ',
      cooked: 'تم الطهي',
      delivering: 'في انتظار التوصيل',
      delivered: 'تم التوصيل'
    },
    list: {
      buttons: {
        goToControlPanel: 'الذهاب إلى لوحة الإدارة'
      },
      actions: {
        addANew: 'إضافة جديد',
        edit: 'تعديل',
        delete: 'حذف',
        view: 'عرض'
      },
      entitiesName: {
        menu: 'قائمة',
        category: 'فئة',
        categoryPlaceholder: 'اختر فئة',
        product: 'عنصر',
        customer: 'عميل',
        table: 'طاولة',
        tax: 'ضريبة',
        taxPlaceholder: 'اختر ضريبة',
        shipping: 'توصيل',
        otherCharge: 'رسوم إضافية',
        user: 'مستخدم',
        order: 'طلب',
        role: 'دور',
        about: 'معلومات'
      },
      messages: {
        confirmDelete: 'تأكيد الحذف',
        confirmAccept: 'تأكيد العنصر',
        confirmProduct: 'هل تريد قبول هذا العنصر؟',
        deleteCategory: 'هل تريد حذف هذه الفئة؟',
        deleteRestaurant: 'هل تريد حذف هذا النشاط التجاري؟',
        deleteOrder: 'هل تريد حذف هذا الطلب؟',
        deleteCredit: 'هل تريد حذف هذا الائتمان؟',
        deleteWorkSheet: 'هل تريد حذف ورقة العمل هذه؟',
        deleteCustomer: 'هل تريد حذف هذا العميل؟',
        deleteMenu: 'هل تريد حذف هذه القائمة؟',
        deleteOtherCharge: 'هل تريد حذف هذه الرسوم الإضافية؟',
        deleteNewsletter: 'هل تريد حذف هذه النشرة الإخبارية؟',
        deleteProduct: 'هل تريد حذف هذا العنصر؟',
        deleteShipping: 'هل تريد حذف هذه التوصيلة؟',
        deleteTable: 'هل تريد حذف هذه الطاولة؟',
        deleteTax: 'هل تريد حذف هذه الضريبة؟',
        deleteUser: 'هل تريد حذف هذا المستخدم؟',
        deleteSuscriptor: 'هل تريد حذف هذا المشترك؟',
        deleteRole: 'هل تريد حذف هذا الدور؟',
        deleteAbout: 'هل تريد حذف هذه المعلومات؟',
        deleteDisplay: 'هل تريد إزالة هذا الإعلان؟',
        deleteOccupation: 'هل تريد حذف هذه المهنة؟',
        deleteVariantGroup: 'هل تريد حذف هذه الخيارات؟',
        infoDeleteSuccess: 'معلومات',
        invalidCode: 'رمز غير صالح، يرجى المحاولة مرة أخرى.',
        messageDeleteSuccessCategory: 'تم حذف الفئة بنجاح',
        messageDeleteSuccessRestaurant: 'تم حذف النشاط التجاري بنجاح',
        messageDeleteSuccessOrder: 'تم حذف الطلب بنجاح',
        messageDeleteSuccessCredit: 'تم حذف الائتمان بنجاح',
        messageDeleteSuccessWorkSheet: 'تم حذف ورقة العمل بنجاح',
        messageDeleteSuccessCustomer: 'تم حذف العميل بنجاح',
        messageDeleteSuccessMenu: 'تم حذف القائمة بنجاح',
        messageDeleteSuccessOtherCharges: 'تم حذف الرسوم الإضافية بنجاح',
        messageDeleteSuccessNewsletter: 'تم حذف النشرة الإخبارية بنجاح',
        messageDeleteSuccessProduct: 'تم حذف العنصر بنجاح',
        messageDeleteSuccessShipping: 'تم حذف التوصيلة بنجاح',
        messageDeleteSuccessTable: 'تم حذف الطاولة بنجاح',
        messageDeleteSuccessTax: 'تم حذف الضريبة بنجاح',
        messageDeleteSuccessUser: 'تم حذف المستخدم بنجاح',
        messageDeleteSuccessSuscriptor: 'تم حذف المشترك بنجاح',
        messageActivareSuccessSuscriptor: 'تم تفعيل المشترك بنجاح',
        messageDesactivareSuccessSuscriptor: 'تم إلغاء تفعيل المشترك بنجاح',
        messageDeleteSuccessRole: 'تم حذف الدور بنجاح',
        messageDeleteSuccessAbout: 'تم حذف المعلومات بنجاح',
        messageDeleteSuccessOccupation: 'تم حذف المهنة بنجاح',
        messageDeleteSuccessVariantGroup: 'تم حذف الخيارات بنجاح',
        messageCateringApproved: 'تمت الموافقة على طلب التموين بنجاح',
        messageCateringCancelled: 'تم إلغاء طلب التموين بنجاح',
        titleEditCategory: 'تعديل الفئة',
        titleEditCustomer: 'تعديل العميل',
        titleEditMenu: 'تعديل القائمة',
        titleEditOtherCharges: 'تعديل الرسوم الإضافية',
        titleEditProduct: 'تعديل العنصر',
        titleEditShipping: 'تعديل التوصيلة',
        titleEditTable: 'تعديل الطاولة',
        titleEditTax: 'تعديل الضريبة',
        titleEditUser: 'تعديل المستخدم',
        titleEditRole: 'تعديل الدور',
        titleEditSetting: 'تعديل الإعدادات',
        titleEditOccupation: 'تعديل المهنة',
        titleCreateCategory: 'إنشاء فئة',
        titleCreateCustomer: 'إنشاء عميل',
        titleCreateMenu: 'إنشاء قائمة',
        titleCreateOtherCharges: 'إنشاء رسوم إضافية',
        titleCreateProduct: 'إنشاء عنصر',
        titleCreateShipping: 'إنشاء توصيلة',
        titleCreateTable: 'إنشاء طاولة',
        titleCreateTax: 'إنشاء ضريبة',
        titleCreateUser: 'إنشاء مستخدم',
        titleCreateRole: 'إنشاء دور',
        titleCreateSetting: 'إنشاء إعدادات',
        titleCreateOccupation: 'إنشاء مهنة',
        titleEditVariantGroup: 'تعديل الخيارات',
        titleCreateVariantGroup: 'إنشاء خيارات جديدة',
        messageEditSuccessCategory: 'تم تعديل الفئة بنجاح',
        messageEditSuccessCredit: 'تم تعديل الائتمان بنجاح',
        messageEditSuccessCustomer: 'تم تعديل العميل بنجاح',
        messageEditSuccessMenu: 'تم تعديل القائمة بنجاح',
        messageEditSuccessWorksheet: 'تم تعديل ورقة العمل بنجاح',
        messageEditSuccessOtherCharges: 'تم تعديل الرسوم الإضافية بنجاح',
        messageEditSuccessProduct: 'تم تعديل العنصر بنجاح',
        messageEditSuccessShipping: 'تم تعديل التوصيلة بنجاح',
        messageEditSuccessTable: 'تم تعديل الطاولة بنجاح',
        messageEditSuccessTax: 'تم تعديل الضريبة بنجاح',
        messageEditSuccessUser: 'تم تعديل المستخدم بنجاح',
        messageEditSuccessSuscriptor: 'تم تعديل المشترك بنجاح',
        messageEditSuccesRole: 'تم تعديل الدور بنجاح',
        messageEditSuccessSetting: 'تم تعديل الإعدادات بنجاح',
        messageEditSuccessOccupation: 'تم تعديل المهنة بنجاح',
        messageEditSuccessVariantGroup: 'تم تعديل الخيارات بنجاح',
        messageDeleteSuccessVariant: 'تم حذف الخيارات بنجاح',
        messageEditSuccessVariant: 'تم تعديل الخيارات بنجاح',
        messageCreateSuccessVariant: 'تم إنشاء الخيارات بنجاح',
        messageCreateSuccessCategory: 'تم إنشاء الفئة بنجاح',
        messageCreateSuccessCredit: 'تم إنشاء الائتمان بنجاح',
        messageCreateSuccessCustomer: 'تم إنشاء العميل بنجاح',
        messageCreateSuccessMenu: 'تم إنشاء القائمة بنجاح',
        messageCreateSuccessWorksheet: 'تم إنشاء ورقة العمل بنجاح',
        messageCreateSuccessOtherCharges: 'تم إنشاء الرسوم الإضافية بنجاح',
        messageCreateSuccessProduct: 'تم إنشاء العنصر بنجاح',
        messageCreateSuccessShipping: 'تم إنشاء التوصيلة بنجاح',
        messageCreateSuccessTable: 'تم إنشاء الطاولة بنجاح',
        messageCreateSuccessTax: 'تم إنشاء الضريبة بنجاح',
        messageCreateSuccessUser: 'تم إنشاء المستخدم بنجاح',
        messageCreateSuccessSuscriptor: 'تم إنشاء المشترك بنجاح',
        messageCreateSuccessRole: 'تم إنشاء الدور بنجاح',
        messageCreateSuccessSetting: 'تم إنشاء الإعدادات بنجاح',
        messageCreateSuccessOccupation: 'تم إنشاء المهنة بنجاح',
        messageCreateSuccessVariantGroup: 'تم إنشاء الخيارات بنجاح',
        menuChangeState: 'تم تغيير حالة القائمة بنجاح',
        activeMenu: 'تفعيل القائمة',
        otherChargeChangeState: 'تم تغيير حالة الرسوم الإضافية بنجاح',
        activeOtherCharge: 'تفعيل الرسوم الإضافية',
        taxChangeState: 'تم تغيير حالة الضريبة بنجاح',
        activeTax: 'تفعيل الضريبة',
        shippingChangeState: 'تم تغيير حالة التوصيلة بنجاح',
        activeShipping: 'تفعيل التوصيل',
        deleteSubtitleCategory: 'حذف الفئة',
        deleteSubtitleCustomer: 'حذف العميل',
        deleteSubtitleMenu: 'حذف القائمة',
        deleteSubtitleOtherCharges: 'حذف الرسوم الإضافية',
        deleteSubtitleProduct: 'حذف العنصر',
        deleteSubtitleShipping: 'حذف التوصيلة',
        deleteSubtitleTable: 'حذف الطاولة',
        deleteSubtitleTax: 'حذف الضريبة',
        deleteSubtitleUser: 'حذف المستخدم',
        deleteSubtitleRole: 'حذف الدور',
        deleteSubtitleAbout: 'حذف المعلومات',
        deleteSubtitleOccupation: 'حذف المهنة',
        deleteSubtitleVariantGroup: 'حذف الخيارات',
        deleteAertMessage: 'هل أنت متأكد أنك تريد حذف جهة الاتصال.',
        errorTitle: 'خطأ',
        errorMessage: 'حدث خطأ ما.',
        changeOrderStateMessage: 'تغيير حالة الطلب',
        changeOrderStateSuccess: 'تم تغيير حالة الطلب بنجاح',
        changeOrderStateCanceled: 'تم إلغاء الطلب',
        connectionError: 'خطأ في الاتصال',
        sharedWorksheet: 'تم مشاركة ورقة العمل مع عضو الموظف',
        connectionErrorMessage: 'حدث خطأ في الاتصال. يرجى التحقق من اتصالك بالإنترنت وإعادة المحاولة. إذا استمرت المشكلة، يرجى الاتصال بمزود الخدمة الخاص بك.',
        newPasswordSent: 'تم إرسال كلمة المرور الجديدة إلى بريدك الإلكتروني',
        emailOrPasswordIncorrect: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
        buttons: {
          cancel: 'إلغاء',
          delete: 'حذف',
          close: 'إغلاق',
          goToAdministration: 'الذهاب إلى الإدارة',
          goToList: 'الذهاب إلى القائمة',
          retry: 'إعادة المحاولة'
        }
      }
    },
    form: {
      includeMiddleName: 'إضافة الاسم الأوسط',
      login: 'تسجيل الدخول',
      events: {
        backgroundImage: 'صورة الخلفية',
        backgroundColor: 'لون الخلفية',
        backgroundColorSection: 'إضافة لون خلفية لهذا القسم',
        backgroundColorDates: 'لون خلفية للتواريخ',
        backgroundColorTitle: 'لون خلفية للعنوان',
        backgroundColorSubtitle: 'لون خلفية للعنوان الفرعي',
        backgroundColorDescription: 'لون خلفية للوصف',
        backgroundColorFooter: 'لون خلفية للتذييل',
        startDate: 'تاريخ البدء',
        endDate: 'تاريخ الانتهاء',
        startTime: 'وقت البدء',
        endTime: 'وقت الانتهاء',
        dates: 'التواريخ',
        title: 'العنوان',
        subtitle: 'العنوان الفرعي',
        description: 'الوصف',
        footer: 'تذييل',
        saveToCalendar: 'إضافة إلى تقويم جوجل'
      },
      colour: {
        primaryColor: 'اللون الأساسي',
        primary: 'أساسي',
        primaryText: 'نص أساسي',
        secondaryColor: 'اللون الثانوي',
        secondary: 'ثانوي',
        secondaryText: 'نص ثانوي',
        tertiaryColor: 'اللون الثالث',
        tertiary: 'ثالث',
        tertiaryText: 'نص ثالث',
        successColor: 'لون النجاح',
        success: 'نجاح',
        successText: 'نص النجاح',
        dangerColor: 'لون الخطر',
        danger: 'خطر',
        dangerText: 'نص الخطر',
        backgroundColor: 'لون الخلفية',
        background: 'خلفية'
      },
      tableShape: {
        square: 'مربع',
        rectangular: 'مستطيل',
        circle: 'دائرة',
        oval: 'بيضاوي'
      },
      buttons: {
        backToCategoriesList: 'العودة إلى قائمة الفئات',
        backToCustomersList: 'العودة إلى قائمة العملاء',
        backToMenusList: 'العودة إلى قائمة القوائم',
        backToOrdersList: 'العودة إلى قائمة الطلبات',
        backToOtherChargesList: 'العودة إلى قائمة الرسوم الإضافية',
        backToProductsList: 'العودة إلى قائمة العناصر',
        backToShippingsList: 'العودة إلى قائمة التوصيلات',
        backToTablesList: 'العودة إلى قائمة الطاولات',
        backToTaxesList: 'العودة إلى قائمة الضرائب',
        backToUsersList: 'العودة إلى قائمة المستخدمين',
        backToRolesList: 'العودة إلى قائمة الأدوار',
        backToAboutList: 'العودة إلى قائمة المعلومات',
        backToMenu: 'العودة إلى القائمة',
        cancelOrder: 'إلغاء الطلب',
        changeState: 'تغيير الحالة إلى',
        defaultColor: 'افتراضي',
        addChoice: 'إضافة متغير',
        back: 'رجوع',
        save: 'حفظ',
        submit: 'إرسال',
        change: 'تغيير',
        add: 'إضافة',
        update: 'تحديث'
      },
      titles: {
        identificationInformation: 'معلومات التعريف',
        idType: 'نوع الهوية',
        driverLicense: 'رخصة القيادة',
        internationalId: 'الهوية الدولية (بطاقة الهوية)',
        nameLicense: 'الاسم على الرخصة',
        licenseNumber: 'رقم الرخصة',
        issueDate: 'تاريخ الإصدار',
        expirationDate: 'تاريخ الانتهاء',
        sex: 'الجنس',
        dateBirth: 'تاريخ الميلاد',
        meters: "أمتار",
        feet: "أقدام",
        centimeters: "سنتيمترات",
        inches: "بوصات",
        height: 'الطول',
        nameId: 'الاسم على الهوية',
        identificationNumber: 'رقم الهوية',
        nationality: 'الجنسية',
        martialStatus: 'الحالة الاجتماعية',
        single: 'أعزب',
        married: 'متزوج',
        divorced: 'مطلق',
        widowed: 'أرمل',
        occupation: 'المهنة',
        socialeMediaChannels: 'قنوات التواصل الاجتماعي',
        customerType: 'نوع العميل',
        customerStatus: 'حالة العميل',
        gender: 'النوع',
        preferredContact: 'طريقة الاتصال المفضلة',
        enableAll: 'تفعيل الكل',
        disableAll: 'تعطيل الكل',
        invoiceReminderLabel: 'أدخل عدد الأيام التي سيتم فيها إرسال تذكير',
        invoiceReminder: 'تشغيل تذكير الفواتير',
        assetPickupRequest: 'طلب استلام الأصول',
        pickupAddress: 'عنوان الاستلام',
        requireDeposit: 'يتطلب وديعة',
        lateFees: 'تشغيل رسوم التأخير على الفاتورة',
        lateFeesLabel: 'أدخل نسبة المتأخرات التي سيتم تحصيلها',
        thisInvoice: 'تم دفع هذه الفاتورة',
        customerNewTitle: 'إنشاء عميل جديد',
        customerEditTitle: 'تعديل العميل',
        categoryNewTitle: 'إنشاء فئة جديدة',
        creditNewTitle: 'إنشاء ائتمان جديد',
        categoryEditTitle: 'تعديل الفئة',
        creditEditTitle: 'تعديل الائتمان',
        menuNewTitle: 'إنشاء قائمة جديدة',
        workSheetNewTitle: 'إنشاء ورقة عمل',
        menuEditTitle: 'تعديل القائمة',
        workSheetEditTitle: 'تعديل ورقة العمل',
        productNewTitle: 'إنشاء عنصر',
        serviceNewTitle: 'إنشاء خدمة',
        productEditTitle: 'تعديل العنصر',
        serviceEditTitle: 'تعديل الخدمة',
        changePaymentSetting: 'تغيير إعدادات الدفع',
        shippingNewTitle: 'إنشاء سعر توصيل جديد',
        shippingEditTitle: 'تعديل سعر التوصيل',
        taxNewTitle: 'إنشاء ضريبة جديدة',
        taxEditTitle: 'تعديل الضريبة',
        tableNewTitle: 'إنشاء طاولة جديدة',
        tableEditTitle: 'تعديل الطاولة',
        packageNewTitle: 'إنشاء حزمة جديدة',
        packageEditTitleditTitle: 'تعديل الحزمة',
        variantGroupEditTitle: 'تعديل الخيارات',
        variantGroupNewTitle: 'إنشاء خيار جديد',
        otherChargeNewTitle: 'إنشاء رسوم إضافية جديدة',
        otherChargeEditTitle: 'تعديل الرسوم الإضافية',
        userNewTitle: 'إنشاء عضو موظف جديد',
        suscriptionNewTitle: 'إنشاء اشتراك جديد',
        driversNewTitle: 'إنشاء سائق جديد',
        userEditTitle: 'تعديل عضو الموظف',
        suscriptionEditTitle: 'تعديل الاشتراك',
        driversEditTitle: 'تعديل السائق',
        supportUsers: 'مستخدمي الدعم',
        occupationNewTitle: 'إنشاء مهنة/وظيفة جديدة',
        occupationEditTitle: 'تعديل المهنة/الوظيفة',
        roleNewTitle: 'إضافة أذونات',
        roleEditTitle: 'تعديل الدور',
        selectAProduct: 'اختر عنصرًا',
        selectACategory: 'اختر فئة',
        selectACustomer: 'اختر عميلًا',
        selectATax: 'اختر ضريبة',
        selectARestaurant: 'اختر نشاطًا تجاريًا',
        selectAState: 'اختر ولاية',
        filterCategory: 'تصفية...',
        selectALanguage: 'اللغة',
        selectAnOccupation: 'اختر مهنة',
        selectACooker: 'اختر طباخًا',
        selectADriver: 'اختر سائقًا',
        allProducts: 'جميع العناصر:',
        settingEditTitle: 'تعديل الإعدادات',
        settingNewTitle: 'إضافة إعدادات',
        generalSettingEditTitle: 'تعديل الإعدادات الأساسية',
        generalSettingNewTitle: 'إضافة إعدادات أساسية',
        keySettingEditTitle: 'تعديل إعدادات النظام',
        keySettingNewTitle: 'إنشاء إعدادات النظام',
        funSettingEditTitle: 'إعدادات الوظائف',
        funSettingNewTitle: 'إنشاء إعدادات الوظائف',
        pickFromSelect: 'اختر من',
        pickToSelect: 'اختر إلى',
        dateFromSelect: 'اختر التاريخ من',
        dateToSelect: 'اختر التاريخ إلى',
        cancelOrder: 'إلغاء الطلب',
        drivers: 'السائقون',
        customer: 'العميل',
        date: 'التاريخ',
        startDate: 'تاريخ البدء',
        endDate: 'تاريخ الانتهاء',
        orderType: 'نوع الطلب',
        addressToDelivery: 'عنوان التوصيل',
        hourToPick: 'ساعة الاستلام',
        tableService: 'خدمة الطاولة',
        products: 'العناصر',
        services: 'الخدمات',
        otherCharges: 'رسوم إضافية',
        shippingPrice: 'سعر التوصيل',
        subtotal: 'المجموع الفرعي',
        tax: 'إجمالي الضريبة',
        tip: 'بقشيش',
        total: 'الإجمالي',
        number: 'الرقم',
        doYou: 'هل تريد حقًا حذف',
        marked: 'السجلات المحددة؟',
        pendingPay: 'دفع معلق',
        payed: 'تم الدفع',
        notes: 'ملاحظات',
        cancelNotes: 'ملاحظات الإلغاء',
        pickupNotes: 'ملاحظات الاستلام',
        cooker: 'الطباخ',
        state: 'الحالة',
        generalConfiguration: 'التكوينات العامة',
        paymentConfiguration: 'تكوينات الدفع',
        cashDiscount: 'خصم نقدي',
        eposConfiguration: 'تكوين EPOS',
        emailConfiguration: 'تكوينات البريد الإلكتروني',
        twilioSMS: 'Twilio SMS',
        sinchSMS: 'Sinch SMS',
        selectAVariantGroup: 'اختر خيارًا',
        imageText: 'للحصول على نتائج أفضل، يرجى تحميل صورة بحجم 750x750 بكسل. تأكد من أن لديك حقوق أي صورة تقوم بتحميلها',
        orderCateringForm: 'موافقة على طلب التموين',
        restaurantHours: 'ساعات العمل',
        deadlinesNotes: 'يرجى التأكد من أن مجموع المواعيد النهائية هو 100.',
        selectDate: 'اختر تاريخًا',
        toPay: 'للدفع',
        pending: 'معلق',
        genaral: 'عام',
        others: 'أخرى',
        variants: 'متغيرات',
        sides: 'إضافات',
        ingredients: 'مكونات',
        shift4: 'Shift4',
        auth: 'Authorize.Net',
        capcha: 'كابتشا',
        zipCodes: 'الرموز البريدية',
        backups: 'النسخ الاحتياطية',
        devices: 'الأجهزة',
        creditSetting: 'إعدادات الائتمان'
      },
      fields: {
        createNewCustomer: 'إنشاء عميل جديد',
        editItem: 'تعديل العنصر',
        previewInvoice: 'معاينة الفاتورة',
        companyName: 'اسم الشركة',
        companyEmail: 'بريد الشركة الإلكتروني',
        companyPhone: 'هاتف الشركة',
        companyTitle: 'المسمى الوظيفي',
        companyWebSite: 'موقع الشركة الإلكتروني',
        companyIndustry: 'صناعة الشركة',
        addNewCustomer: 'إضافة عميل جديد',
        projectName: 'اسم المشروع',
        billingAddress: 'عنوان الفوترة',
        selectCustomerAttachBillingAddress: 'اختر عميلًا لإرفاق عنوان فوترة',
        selectCustomerAttachShippingAddress: 'اختر عميلًا لإرفاق عنوان شحن',
        selectedAddress: 'العنوان المحدد:',
        changeAddress: 'تغيير',
        addAddress: 'إضافة',
        number: 'الرقم',
        shippingAddress: 'عنوان الشحن',
        username: 'اسم المستخدم',
        emailLabel: 'البريد الإلكتروني',
        phoneLabel: 'الهاتف',
        firstNameLabel: 'الاسم الأول',
        lastNameLabel: 'الاسم الأخير',
        putEmail: 'أدخل بريدك الإلكتروني',
        putPhone: 'أدخل هاتفك',
        putFirstName: 'أدخل اسمك الأول',
        putLastName: 'أدخل اسمك الأخير',
        putUserName: 'أدخل اسم المستخدم',
        takePicture: 'التقاط صورة',
        accept: 'قبول',
        hidde: 'إخفاء',
        delete: 'حذف',
        retake: 'إعادة التقاط',
        previewPhoto: 'معاينة الصورة',
        previewAcceptedPhoto: 'معاينة الصورة المقبولة',
        viewImenuBookControlPanel: 'عرض iMenuBooks في لوحة التحكم',
        viewImenuEngageControlPanel: 'عرض iMenuEngage360 في لوحة التحكم',
        viewImenuBookOptions: 'عرض خيارات iMenuBooks',
        viewOrdersOption: 'عرض خيار الطلب',
        viewReservationOption: 'عرض خيار الحجز',
        viewInvoiceOption: 'عرض خيار الفاتورة',
        viewQuoteOption: 'عرض خيار عرض السعر',
        changeImage: 'تغيير الصورة',
        addImage: 'إضافة صورة',
        customerHours: 'ساعات العميل',
        to: 'إلى',
        subject: 'الموضوع',
        message: 'الرسالة',
        name: 'الاسم',
        menuName: 'اسم القائمة',
        description: 'الوصف',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        date: 'التاريخ',
        image: 'الصورة',
        phone: 'الهاتف',
        productMin: 'الحد الأدنى للعنصر',
        productMax: 'الحد الأقصى للعنصر',
        price: 'السعر',
        extraCharge: 'رسوم إضافية',
        costPrice: 'التكلفة',
        retailPrice: 'البيع',
        stimateTime: 'الوقت المقدر (بالدقائق)',
        stockQuantity: 'كمية المخزون',
        minReorderPoint: 'الحد الأدنى لكمية المخزون',
        maxReorderPoint: 'الحد الأقصى لكمية المخزون',
        CreditAmount: 'مبلغ الائتمان',
        vendorName: 'اسم المورد',
        vendorCode: 'كود المورد',
        shortDescription: 'وصف مختصر',
        keywords: 'الكلمات المفتاحية',
        tags: 'العلامات',
        binNumber: 'رقم الصندوق',
        addSerialNumber: 'إضافة رقم تسلسلي',
        active: 'تفعيل',
        save: 'حفظ',
        submitToken: 'إرسال الرمز',
        available: 'متاح',
        availableCategories: 'الفئات المتاحة',
        availableProducts: 'العناصر المتاحة',
        availableStaff: 'الموظفون المتاحون',
        selectedProducts: 'العناصر المحددة',
        selectedCategories: 'الفئات المحددة',
        selectedStaff: 'الموظفون المحددون',
        workedHours: 'ساعات العمل',
        scheduledDates: 'التواريخ المجدولة',
        selectedAggregates: 'المجمعات المحددة',
        marketingConsent: 'موافقة التسويق',
        product: 'العنصر',
        category: 'الفئة',
        tax: 'الضريبة',
        parentCategory: 'الفئة الرئيسية',
        qrCode: 'رمز الاستجابة السريعة',
        capacity: 'السعة',
        percent: 'النسبة المئوية',
        priority: 'الأولوية (0 - 1)',
        permissions: 'الأذونات',
        permissionsRole: 'أذونات الأدوار',
        selectCashDiscount: 'اختر خصم نقدي',
        roles: 'المهنة/الوظيفة',
        address: 'العنوان',
        title: 'العنوان',
        subtitle: 'العنوان الفرعي',
        online: 'عبر الإنترنت',
        showOtherRestaurant: 'إظهار أنشطة تجارية أخرى',
        reservationByTable: 'حجز طاولة',
        reservationByStaff: 'حجز موظف',
        tablesChoose: 'يمكن للعميل اختيار موقع الطاولة',
        onlineMss: 'النشاط التجاري غير مرئي للجمهور',
        onlineMss1: 'النشاط التجاري مرئي للجمهور',
        mustClockinMss: 'يجب عليك تسجيل الدخول أولاً. يرجى',
        mustClockin2Mss: 'تسجيل الدخول.',
        SelectPickHour: 'اختر ساعة الاستلام',
        SelectPickHour2: 'تفعيل وقت الاستلام',
        TipRequire: 'يتطلب بقشيشًا',
        tips: 'البقشيش',
        assetPickup: 'استلام الأصول',
        depositAmount: 'مبلغ الوديعة',
        typeTip: 'اكتب نسبة البقشيش',
        MinTimeToCook: 'الحد الأدنى لوقت الطهي',
        PickFrom: 'بدء الاستلام من',
        PickFromToolTip: 'أضف وقت بدء التوصيل',
        PickTo: 'نهاية وقت الاستلام',
        PickToToolTip: 'أضف وقت انتهاء التوصيل',
        DateFrom: 'التاريخ من',
        DateTo: 'التاريخ إلى',
        DateLimit: 'الحد الزمني للدفع',
        ShowCooker: 'إظهار الطباخ',
        zipCodes: 'الرموز البريدية',
        deliveryZone: 'مناطق التوصيل',
        cooker: 'الطباخ',
        driver: 'السائق',
        rejectedOrder: 'تم رفض الطلب من قبل السائق',
        cancelationNote: 'ملاحظة الإلغاء',
        tableNumber: 'رقم الطاولة',
        firstName: 'الاسم الأول',
        lastName: 'الاسم الأخير',
        occupation: 'المهنة',
        confirmPassword: 'تأكيد كلمة المرور',
        endPointUrl: 'رابط النقطة النهائية',
        capchaKey: 'مفتاح الكابتشا',
        clientGuid: 'معرف العميل',
        interfazVersion: 'إصدار الواجهة',
        interfazName: 'اسم الواجهة',
        apiLoginId: 'معرف تسجيل الدخول API',
        eposToken: 'رمز ePos',
        epos: 'التكامل مع ePos',
        transactionKey: 'مفتاح المعاملة',
        smtpHost: 'مضيف SMTP',
        port: 'المنفذ',
        secure: 'آمن',
        twFromNumber: 'من رقم',
        twAccountSID: 'معرف حساب SID',
        twToken: 'الرمز',
        sinchFromNumber: 'من رقم',
        sinchAccountSID: 'معرف خطة الخدمة',
        sinchToken: 'الرمز',
        web: 'الموقع الإلكتروني',
        variantGroup: 'الخيارات',
        haveSides: 'إضافات',
        cantOfSides: 'عدد الإضافات المضمنة',
        categoryOfSides: 'تصفية الإضافات حسب الفئة',
        addIngredients: 'تحديد المكونات',
        typeAnIngredient: 'اكتب مكونًا',
        canViewGeoposition: 'يمكن عرض الموقع الجغرافي',
        canViewRating: 'يمكن عرض التقييم',
        viewDelivery: 'يمكن إنشاء طلبات التوصيل',
        viewOnTable: 'يمكن إنشاء طلبات الطاولة',
        viewCurbside: 'يمكن إنشاء طلبات الرصيف',
        tablePrefix: 'بادئة الطاولة',
        barPrefix: 'بادئة البار',
        roomPrefix: 'بادئة الغرفة',
        typeZipCode: 'أدخل رمزًا بريديًا',
        isCatering: 'تموين',
        isService: 'قائمة الخدمة',
        isReservationMenu: 'قائمة الحجز',
        catering: 'التموين',
        minAmoutCatering: 'الحد الأدنى لمبلغ التموين',
        minAmountCateringDelivery: 'الحد الأدنى لمبلغ التوصيل',
        loyaltyMinPointToBuy: 'الحد الأدنى للنقاط للشراء',
        loyaltyExpirationMonths: 'عدد أشهر انتهاء الولاء',
        loyaltyPointMoney: 'عدد النقاط لكل 1 دولار',
        partialPay: 'دفع جزئي',
        payForQuotation: 'الدفع المسبق لعرض السعر',
        percentPayForQuotation: 'مبلغ الدفع المسبق لعرض السعر',
        service: 'الخدمة',
        showServicePrice: 'إظهار سعر الخدمة',
        viewCatering: 'عرض التموين',
        viewLoyalty: 'عرض برنامج الولاء',
        viewReservation: 'عرض الحجز',
        reservation: 'الحجز',
        loyalty: 'برنامج الولاء',
        minDayToReservation: 'الحد الأدنى لعدد الأيام للحجز',
        viewCustomerReservation: 'عرض حجوزات العملاء',
        sameHourForAllDays: 'نفس الساعة لجميع الأيام',
        followingDays: 'نفس الساعات للأيام التالية',
        timezone: 'المنطقة الزمنية',
        monday: 'الاثنين',
        tuesday: 'الثلاثاء',
        wednesday: 'الأربعاء',
        thursday: 'الخميس',
        friday: 'الجمعة',
        saturday: 'السبت',
        sunday: 'الأحد',
        allDays: 'كل الأيام',
        marginDays: 'الحد الأدنى لعدد الأيام لوضع الطلب',
        cateringStates: 'حالات التموين',
        typeState: 'أدخل رمز الولاية',
        zipCodesExclude: 'الرموز البريدية المضمنة',
        cateringEvents: 'حدث التموين',
        typeEventName: 'أدخل اسم الحدث',
        proposeNewDataTime: 'اقتراح تاريخ/وقت جديد',
        fixed: 'مبلغ ثابت',
        amount: 'المبلغ',
        discount: 'الخصم',
        deadlines: 'المواعيد النهائية',
        pendingPay: 'دفع معلق',
        payed: 'تم الدفع',
        states: 'الحالات',
        paymentMethod: 'طريقة الدفع',
        cash: 'نقدًا',
        card: 'بطاقة',
        check: 'شيك',
        free: 'مجاني',
        busy: 'مشغول',
        dirty: 'متسخ',
        authenticationToken: 'رمز التفويض',
        authenticationTokenMoto: 'رمز تفويض MOTO',
        authenticationTokenFB: 'رمز تفويض F&B',
        accountType: 'نوع الحساب',
        method: 'الطريقة',
        serverName: 'اسم الخادم',
        urlLocation: 'موقع URL',
        fax: 'الفاكس',
        oldServerId: 'معرف الموظف القديم',
        newServerId: 'معرف الموظف الجديد',
        acivateTwilio: 'تفعيل Twilio',
        acivateSinch: 'تفعيل Sinch',
        isDriver: 'سائق',
        monthy: 'شهريًا',
        anual: 'سنويًا',
        merchantOnboardingApplication: 'تطبيق انضاج التاجر',
        applicationName: 'اسم التطبيق',
        agentId: 'معرف الوكيل',
        planId: 'معرف الخطة',
        dateOfBirth: 'تاريخ الميلاد',
        equityOwnershipPercent: 'نسبة ملكية الأسهم',
        isPersonalGuarantor: 'هل هو ضامن شخصي؟',
        bookablePackage: 'حزمة قابلة للحجز',
        showProgressBar: 'إظهار شريط التقدم للسائق'
      },
      messages: {
        buttons: {
          ok: 'موافق',
          dismiss: 'رفض'
        },
        activatePaymentMethod: 'تم تفعيل طريقة الدفع.',
        incorrectToken: 'الرمز المرسل غير صحيح.',
        activationMethodError: 'أرجعت طريقة التفعيل خطأ.',
        unexpectedError: 'حدث خطأ غير متوقع.',
        savePaymentMethodSuccess: 'تم حفظ إعدادات طريقة الدفع بنجاح.',
        savePaymentMethodError: 'حدث خطأ أثناء حفظ إعدادات طريقة الدفع.'
      },
      validate: {
        emailExisteTitle: 'البريد الإلكتروني موجود بالفعل',
        emailExistMessage: 'هذا البريد الإلكتروني مسجل بالفعل. يرجى استخدام عنوان بريد إلكتروني مختلف أو مطالبة المستخدم بالنقر على "نسيت كلمة المرور" في شاشة تسجيل الدخول.',
        validate: 'تحقق',
        validateCategory: 'تحقق من الفئة',
        validateCustomer: 'تحقق من العميل',
        validateMenu: 'تحقق من القائمة',
        validateOtherCharge: 'تحقق من الرسوم الإضافية',
        validateProduct: 'تحقق من العنصر',
        validateShipping: 'تحقق من التوصيل',
        validateTable: 'تحقق من الطاولة',
        validateTax: 'تحقق من الضريبة',
        validateUser: 'تحقق من المستخدم',
        validateRole: 'تحقق من الدور',
        validateSetting: 'تحقق من الإعدادات',
        validateOccupation: 'تحقق من المهنة',
        validateVariantGroup: 'تحقق من الخيارات',
        name: 'الاسم مطلوب',
        image: 'الصورة مطلوبة',
        email: 'البريد الإلكتروني مطلوب',
        phone: 'الهاتف مطلوب',
        emailIncorrect: 'البريد الإلكتروني غير صحيح',
        date: 'التاريخ مطلوب',
        selectedCategories: 'يجب اختيار الفئات',
        productMinNumber: 'يجب أن يكون الحد الأدنى للعنصر رقمًا',
        productMaxNumber: 'يجب أن يكون الحد الأقصى للعنصر رقمًا',
        productMinGreater: 'يجب أن يكون الحد الأدنى للعنصر أكبر من 0',
        productMaxGreater: 'يجب أن يكون الحد الأقصى للعنصر أكبر من 2',
        price: 'يجب أن يكون السعر رقمًا',
        priceGreater: 'يجب أن يكون السعر أكبر من 0',
        product: 'يجب اختيار عنصر',
        costPriceNumber: 'يجب أن يكون سعر التكلفة رقمًا',
        retailPriceNumber: 'يجب أن يكون سعر البيع رقمًا',
        retailPriceShouldBeGreaterThanSalePrice: 'يجب أن يكون سعر التجزئة دائمًا أكبر من سعر البيع',
        costPriceGreater: 'يجب أن يكون سعر التكلفة أكبر من 0',
        retailPriceGreater: 'يجب أن يكون سعر البيع أكبر من 0',
        category: 'يجب اختيار فئة',
        capacity: 'يجب أن تكون السعة رقمًا',
        capacityGreater: 'يجب أن تكون السعة أكبر من 0',
        percent: 'يجب أن تكون النسبة المئوية رقمًا',
        percentGreater: 'يجب أن تكون النسبة المئوية أكبر من 0',
        password: 'كلمة المرور مطلوبة',
        address: 'العنوان مطلوب',
        title: 'العنوان مطلوب',
        subtitle: 'العنوان الفرعي مطلوب',
        zipCode: 'الرمز البريدي غير صالح',
        duplicateZipCode: 'رمز بريدي مكرر',
        cateringPriceZero: 'سعر التموين صفر',
        cooker: 'يجب ملء حقل الطباخ',
        tableNumber: 'يجب أن يكون رقم الطاولة رقمًا',
        tableNumberGreater: 'يجب أن يكون رقم الطاولة أكبر من 0',
        nameDuplicate: 'هناك طاولة بهذا الاسم. يجب تغيير الرقم أو النوع.',
        firstName: 'يجب ملء حقل الاسم الأول',
        lastName: 'يجب ملء حقل الاسم الأخير',
        confirmPassword: 'يجب أن تتطابق حقول كلمة المرور وتأكيد كلمة المرور',
        occupation: 'يجب ملء حقل المهنة',
        notes: 'يجب ملء حقل ملاحظة الإلغاء',
        tip: 'لا يمكن أن يكون البقشيش صفرًا',
        tipRepeat: 'البقشيش موجود. يرجى إدخال رقم جديد.',
        emailDontExist: 'البريد الإلكتروني غير موجود.',
        ingredient: 'المكون موجود بالفعل.'
      },
      permissionsGroup: {
        permissionMenu: 'أذونات القائمة',
        permissionCategory: 'أذونات الفئة',
        permissionProduct: 'أذونات العنصر',
        permissionSpecialPrice: 'أذونات السعر الخاص',
        permissionCustomer: 'أذونات العميل',
        permissionCredit: 'أذونات الائتمان',
        permissionHouseAccount: 'أذونات حساب المنزل',
        permissionTable: 'أذونات الطاولة',
        permissionTax: 'أذونات الضريبة',
        permissionShipping: 'أذونات التوصيل',
        permissionOtherCharge: 'أذونات الرسوم الإضافية',
        permissionUser: 'أذونات الموظف',
        permissionDriver: 'أذونات إشراف السائق',
        permissionDeliveryDriver: 'أذونات سائق التوصيل',
        permissionOrder: 'أذونات الطلب',
        permissionRole: 'أذونات الدور',
        permissionWorkSheet: 'أذونات ورقة العمل',
        permissionSetting: 'أذونات الإعدادات',
        permissionPayment: 'أذونات الدفع',
        permissionReport: 'أذونات التقارير',
        permissionClockin: 'أذونات تسجيل الدخول',
        permissionOccupation: 'أذونات المهنة',
        permissionVariantGroup: 'أذونات الخيارات',
        permissionReservation: 'أذونات الحجز',
        permissionSuscriptors: 'أذونات المشتركين',
        permissionSuscription: 'أذونات الاشتراك',
        canViewMenu: 'يمكن عرض القوائم',
        canCreateMenu: 'يمكن إنشاء القوائم',
        canEditMenu: 'يمكن تعديل القوائم',
        canDeleteMenu: 'يمكن حذف القوائم',
        canViewCategory: 'يمكن عرض الفئات',
        canCreateCategory: 'يمكن إنشاء الفئات',
        canEditCategory: 'يمكن تعديل الفئات',
        canDeleteCategory: 'يمكن حذف الفئات',
        canViewProduct: 'يمكن عرض العناصر',
        canCreateProduct: 'يمكن إنشاء العناصر',
        canEditProduct: 'يمكن تعديل العناصر',
        canDeleteProduct: 'يمكن حذف العناصر',
        canViewSpecialPrices: 'يمكن عرض الأسعار الخاصة',
        canCreateSpecialPrices: 'يمكن إنشاء الأسعار الخاصة',
        canEditSpecialPrices: 'يمكن تعديل الأسعار الخاصة',
        canDeleteSpecialPrices: 'يمكن حذف الأسعار الخاصة',
        canViewCustomer: 'يمكن عرض العملاء',
        canCreateCustomer: 'يمكن إنشاء العملاء',
        canEditCustomer: 'يمكن تعديل العملاء',
        canDeleteCustomer: 'يمكن حذف العملاء',
        canViewCredit: 'يمكن عرض الائتمانات',
        canCreateCredit: 'يمكن إنشاء الائتمانات',
        canEditCredit: 'يمكن تعديل الائتمانات',
        canDeleteCredit: 'يمكن حذف الائتمانات',
        canViewHouseAccount: 'يمكن عرض حساب المنزل',
        canCreateHouseAccount: 'يمكن إنشاء حساب المنزل',
        canCreateSuscriptor: 'يمكن إنشاء المشتركين',
        canViewSuscriptor: 'يمكن عرض المشتركين',
        canEditSuscriptor: 'يمكن تعديل المشتركين',
        canDesactivateSuscriptor: 'يمكن إلغاء تفعيل المشتركين',
        canViewTable: 'يمكن عرض الطاولات',
        canCreateTable: 'يمكن إنشاء الطاولات',
        canEditTable: 'يمكن تعديل الطاولات',
        canDeleteTable: 'يمكن حذف الطاولات',
        canViewTax: 'يمكن عرض الضرائب',
        canCreateTax: 'يمكن إنشاء الضرائب',
        canEditTax: 'يمكن تعديل الضرائب',
        canDeleteTax: 'يمكن حذف الضرائب',
        canViewShipping: 'يمكن عرض التوصيلات',
        canCreateShipping: 'يمكن إنشاء التوصيلات',
        canEditShipping: 'يمكن تعديل التوصيلات',
        canDeleteShipping: 'يمكن حذف التوصيلات',
        canViewOtherCharge: 'يمكن عرض الرسوم الإضافية',
        canCreateOtherCharge: 'يمكن إنشاء الرسوم الإضافية',
        canEditOtherCharge: 'يمكن تعديل الرسوم الإضافية',
        canDeleteOtherCharge: 'يمكن حذف الرسوم الإضافية',
        canViewUser: 'يمكن عرض المستخدمين',
        canCreateUser: 'يمكن إنشاء المستخدمين',
        canEditUser: 'يمكن تعديل المستخدمين',
        canDeleteUser: 'يمكن حذف المستخدمين',
        canViewDriver: 'يمكن عرض السائقين الخارجيين',
        canCreateDriver: 'يمكن إنشاء السائقين الخارجيين',
        canEditDriver: 'يمكن تعديل السائقين الخارجيين',
        canDeleteDriver: 'يمكن حذف السائقين الخارجيين',
        canViewDeliveryDriver: 'يمكن عرض سائق التوصيل',
        canEditDeliveryStatus: 'يمكن تعديل حالة التوصيل',
        canCreateDeliveryDriver: 'يمكن إنشاء سائق التوصيل',
        canDeleteDeliveryDriver: 'يمكن حذف سائق التوصيل',
        canViewOccupation: 'يمكن عرض المهنة',
        canCreateOccupation: 'يمكن إنشاء المهنة',
        canEditOccupation: 'يمكن تعديل المهنة',
        canDeleteOccupation: 'يمكن حذف المهنة',
        canViewRole: 'يمكن عرض الأدوار',
        canCreateRole: 'يمكن إنشاء الأدوار',
        canEditRole: 'يمكن تعديل الأدوار',
        canDeleteRole: 'يمكن حذف الأدوار',
        canViewWorkSheet: 'يمكن عرض ورقة العمل',
        canCreateWorkSheet: 'يمكن إنشاء ورقة العمل',
        canEditWorkSheet: 'يمكن تعديل ورقة العمل',
        canDeleteWorkSheet: 'يمكن حذف ورقة العمل',
        canViewOrder: 'يمكن عرض الطلبات',
        canEditOrder: 'يمكن تعديل الطلبات',
        canCreateOrder: 'يمكن إنشاء الطلبات',
        canViewOrderForDelivery: 'يمكن عرض الطلبات للتوصيل',
        canChangeSetting: 'يمكن تغيير الإعدادات',
        canViewVariantGroup: 'يمكن عرض الخيارات',
        canCreateVariantGroup: 'يمكن إنشاء الخيارات',
        canEditVariantGroup: 'يمكن تعديل الخيارات',
        canDeleteVariantGroup: 'يمكن حذف الخيارات',
        canViewReservation: 'يمكن عرض الحجوزات',
        canCreateReservation: 'يمكن إنشاء الحجوزات',
        canEditReservation: 'يمكن تعديل الحجوزات',
        canDeleteReservation: 'يمكن حذف الحجوزات',
        canViewPayment: 'يمكن عرض المدفوعات',
        canIgnoreClockin: 'يمكن تجاهل تسجيل الدخول',
        canViewSalesByCustomer: 'يمكن عرض المبيعات حسب العميل',
        canViewSalesByProduct: 'يمكن عرض المبيعات حسب المنتج',
        canViewDynamicReports: 'يمكن عرض التقارير الديناميكية',
        canViewSubscription: 'يمكن عرض الاشتراك',
        canCreateSubscription: 'يمكن إنشاء الاشتراك',
        canEditSubscription: 'يمكن تعديل الاشتراك',
        canDeleteSubscription: 'يمكن حذف الاشتراك'
      },
      marketingMessages: {
        orderInfo: 'معلومات الطلب',
        inKitchen: 'مرحبًا! شكرًا لاستخدامك خدمتنا. طلبك الآن في مطبخنا.',
        cooked: 'طلبك جاهز. يبدو رائعًا!',
        delivering: 'طلبك في طريقه إليك الآن. فقط بضع دقائق من فضلك',
        delivered: 'تم تسليم طلبك. بالهنا والشفا!',
        canceled: 'تم إلغاء طلبك',
        cateringApproved: 'تمت الموافقة على طلب التموين الخاص بك. يرجى التحقق من بريدك الإلكتروني للحصول على تفاصيل الطلب.',
        cateringCancel: 'نأسف، تم إلغاء طلب التموين الخاص بك.',
        reservationChangeStatus: 'تغيير حالة الحجز',
        reservationApproved: 'مرحبًا! تمت الموافقة على حجزك لـ',
        reservationApproved2: 'يجب عليك تأكيد الحجز الآن.',
        reservationProposedDateTime: 'مرحبًا! نأسف لأننا لا نستطيع تلبية التاريخ/الوقت الذي طلبته. نقترح تاريخ/وقت جديد:',
        reservationRejected: 'مرحبًا! نأسف لرفض حجزك بسبب عدم وجود سعة كافية.',
        reservationCancel: 'تم إلغاء حجزك. إذا كان لديك أي أسئلة، فلا تتردد في الاتصال بنا.'
      }
    }
  },
  frontend: {
    menu: {
      clockInMessage: 'تم تسجيل الدخول بنجاح',
      signIn: 'تسجيل الدخول',
      chatImenu: 'دعم iMenuApps®',
      trackYourPackage: 'تتبع شحنتك',
      aboutImenu: 'حول iMenuapps®',
      seeLess: 'عرض أقل',
      seeMore: 'عرض المزيد',
      foodAndMoodJournal: 'سجل الطعام والمزاج',
      motivation: `لعرض سجل طلباتك، قم بتنزيل تطبيق iMenuApps® والتسجيل.
           <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">تنزيل من متجر Apple</a> أو 
           <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">الحصول عليه من Google Play</a>.`,
      motivationMobile: 'لعرض سجل طلباتك، سجل في iMenuApps®.',
      menu: 'القائمة',
      shop: 'متجر',
      ads: 'لافتات رقمية',
      credit: 'ائتمانات',
      menuCatering: 'قائمة التموين',
      pickupRequest: 'طلب استلام',
      termsOfUse: 'شروط الاستخدام',
      privacyPolicy: 'سياسة الخصوصية',
      otherPolicy: 'سياسات أخرى',
      reservation: 'حجوزات',
      about: 'معلومات عنا',
      chat: 'محادثة',
      eMarkeeting: 'التسويق الإلكتروني',
      contact: 'اتصل بنا',
      oferts: 'عروض',
      init: 'الرئيسية',
      loginMerchant: 'تسجيل دخول التاجر',
      loginClient: 'تسجيل دخول العميل',
      editProfile: 'تعديل ملفك الشخصي',
      edit: 'تعديل بياناتك',
      log: 'تسجيل الدخول / التسجيل',
      membersLogin:'تسجيل دخول الأعضاء',
      membersRegister: 'تسجيل الأعضاء',
      merchantsLogin:'تسجيل دخول التجار',
      catering: 'خدمة التموين',
      logout: 'تسجيل الخروج',
      logIn: 'تسجيل الدخول',
      profil: 'حسابي',
      profil1: 'الملف الشخصي',
      createUser: 'تسجيل',
      forgotPassword: 'هل نسيت كلمة المرور؟',
      passwordReset: 'إعادة تعيين كلمة المرور',
      newPassword: 'كلمة مرور جديدة',
      newData: 'تعديل بياناتك',
      confirmPassword: 'تأكيد كلمة المرور',
      register: 'تسجيل',
      orders: 'طلبات',
      restaurant: 'انقر أدناه لتحديد نوع النشاط التجاري',
      restablacerPassword: 'إعادة تعيين كلمة المرور',
      updateData: 'تحديث البيانات',
      mssForgotPassword: 'لقد أرسلنا كلمة مرور جديدة إلى بريدك الإلكتروني.',
      errorLogIn: 'بريد إلكتروني أو كلمة مرور غير صحيحة',
      errEmailExist: 'هذا البريد الإلكتروني موجود بالفعل',
      errPassNotCoinc: 'لا تتطابق مع كلمة المرور الجديدة',
      userNotFound: 'بريد إلكتروني غير صحيح',
      refresh: 'تحديث',
      mssUpdateData: 'تم تحديث بياناتك بنجاح',
      mssCreateUser: 'تم إنشاء العميل بنجاح، لقد أرسلنا كلمة المرور الجديدة عبر البريد الإلكتروني.',
      mssPasswordChangedCorrectly: 'تم تحديث كلمة المرور بنجاح',
      ticketMenu: 'فتح تذكرة'
    },
    app: {
      convertToProd: 'تحويل التجربة إلى إنتاج',
      convert: 'تحويل',
      daysOfTrial: 'أيام التجربة',
      trialExpired: 'انتهت فترة التجربة',
      trialMessageExpired: 'انتهت فترة التجربة المجانية لـ iMenuApps®. لمواصلة استخدام القوة الكاملة لـ iMenuApps®، يرجى شراء ترخيص الآن لفتح جميع الميزات. يرجى مراسلتنا عبر البريد الإلكتروني مع اسم نشاطك التجاري إلى support@imenuapps.com',
      allBusiness: 'جميع الأنشطة التجارية',
      hospitality: 'الضيافة',
      reservations: 'الحجوزات',
      service: 'الخدمة',
      entertainment: 'الترفيه',
      retail: 'التجزئة',
      fullText: 'نقدم لكم iMenuApps®: حلّكم التجاري الشامل مع بوابة عملاء محسّنة. يقدم iMenuApps® منصة شاملة مصممة لتلبية كل احتياجات عملك، مما يحدث ثورة في طريقة عملك وتواصلك مع عملائك. لا تقتصر تطبيقاتنا على تمكين الشركات من تبسيط العمليات وزيادة المبيعات فحسب، بل تشمل أيضًا بوابة عملاء متطورة تعزز تجربة العميل. من خلال بوابة العملاء الخاصة بنا، يمكن للعملاء إعادة طلب المنتجات والخدمات بسهولة والحفاظ على سجل شامل لمعاملاتهم وملفاتهم الشخصية مع كل تاجر يتعاملون معه على منصتنا. تعزز هذه الميزة الراحة والكفاءة والتفاعلات الشخصية، مما يقوي في النهاية العلاقة بين الشركات وعملائها القيمين. سواء كنت تعمل في مجال الضيافة أو التجزئة أو الخدمة أو الترفيه، فإن iMenuApps® هو الحل الأمثل المصمم خصيصًا لمتطلبات صناعتك. تتكامل منصتنا المتقدمة بسلاسة مع بوابة العملاء، مما يمكن الشركات من تقديم تجربة سلسة وشخصية لعملائها. اعتمد iMenuApps® وافتح عالمًا من الاحتمالات لعملك. استفد من واجهة المستخدم البديهية والوظائف القوية والبنية التحتية الآمنة، وكلها موجهة لتحسين العمليات وتعزيز علاقات العملاء طويلة الأمد.',
      thisPay: 'تم إجراء هذه الدفعة',
      thisPayDone: 'تم سداد هذه الدفعة بالفعل.',
      selectOrder: 'اختر نوع طلبك',
      selectDetail: 'معلومات بياناتك',
      deliver: 'توصيل',
      pickup: 'استلام',
      table: 'طاولة',
      curbside: 'بجانب الرصيف',
      notClient: 'لا توجد طلبات مرتبطة بهذا العميل. تذكر أن العملاء المسجلين فقط يمكنهم عرض طلباتهم.',
      getOrder: 'للحصول على الطلبات',
      editTitle: 'تعديل بياناتك',
      notPermissionForRating: 'يمكن فقط للمستخدمين المسجلين تقييم النشاط التجاري',
      thanksForRating: 'شكرًا على تقييمك',
      sessionExpired: 'انتهت جلستك بسبب عدم النشاط. يرجى تسجيل الدخول مرة أخرى.',
      notRestaurantFound: 'النشاط التجاري المطلوب غير موجود. نأمل أن تجد نشاطًا آخر تفضله في قائمتنا.',
      all: 'الكل',
      productsAndServices: 'المبيعات',
      reservation: 'الحجوزات'
    },
    product: {
      title: 'عناصر',
      back: 'رجوع',
      noProducts: "عذرًا! لا توجد عناصر في هذه الفئة بعد.",
      productDetail: 'تفاصيل العنصر',
      massageToast: 'نجاح',
      productNote: 'أدخل ملاحظة العنصر هنا...',
      productWithVariant: 'انقر على إضافة لخيارات أخرى'
    },
    home: {
      country: 'البلد',
      stateProvince: 'الولاية/المحافظة/المنطقة',
      county: 'المقاطعة',
      autocomplete: 'ابدأ بإدخال عنوانك هنا ليتم ملؤه تلقائيًا',
      selectCategory: 'فئات القائمة',
      cardTitle: 'تفاصيل السلة',
      cardheader: 'العناصر',
      cancel: 'إلغاء',
      acept: 'موافق',
      confirm: 'تأكيد',
      clear: 'مسح',
      checkout: 'الدفع',
      deliverDetail: 'تفاصيل التوصيل',
      address: 'العنوان',
      pickupDetail: 'تفاصيل الاستلام',
      curbsideDetail: 'تفاصيل بجانب الرصيف',
      cateringDate: 'تاريخ التموين',
      pickTime: 'وقت الاستلام غير متاح. يرجى اختيار وقت استلام آخر',
      tableQr: 'رمز QR للموقع',
      notValidQr: 'رمز QR غير صالح',
      notSeatAvailable: 'هذا المقعد محجوز بالفعل',
      errorRequired: 'أدخل المعلومات المطلوبة',
      errorDateNotValid: 'تاريخ غير صالح',
      noProductForReorder: 'لا يوجد أي عنصر متاح لإعادة الطلب.',
      noProductAvailable: 'العناصر التالية غير متوفرة اليوم ولن تظهر في الطلب.',
      clientRequired: 'هذا الإجراء مسموح به فقط للمستخدمين المسجلين. سجل الدخول.',
      cantNotValid: 'كمية العنصر غير صالحة',
      zipCodeNotValid: 'الرمز البريدي غير صالح.',
      notZoneToDeliver: 'حاليًا لا نقدم التوصيل في هذه المنطقة.',
      state: 'الولاية',
      city: 'المدينة',
      notValidEmail: 'بريد إلكتروني غير صالح',
      reqSuccess: 'تم إرسال طلب التغيير بنجاح!',
      approveSuccess: 'تمت الموافقة على طلب التغيير بنجاح!',
      alertDeleteData: 'هل تريد البدء من جديد؟',
      notTimeToPick: 'ساعات الاستلام بين: ',
      cookTime: '. الوقت المقدر للطهي هو ',
      priceEstimated: 'السعر المقدر',
      minuts: ' دقيقة.',
      selectOrderType: 'الرجاء اختيار نوع طلبك.',
      search: 'بحث',
      aggregateFree: 'مشمول مجانًا',
      sides: 'إضافات',
      choises: 'مكونات',
      variants: 'متغيرات',
      withoutIngredients: 'بدون مكونات',
      eventType: 'نوع الحدث',
      emailSended: 'تم إرسال البريد الإلكتروني',
      choseView: 'عروض اختيارية',
      applicationCreateSuccess: 'تم إنشاء التطبيق بنجاح',
      applicationCreateError: 'حدث خطأ أثناء إنشاء التطبيق'
    },
    genderOptions: {
      male: 'ذكر',
      female: 'أنثى',
      nonBinary: 'غير ثنائي',
      transgenderMale: 'ذكر متحول جنسيًا',
      transgenderFemale: 'أنثى متحولة جنسيًا',
      genderqueer: 'كوير جندري',
      genderfluid: 'سائل جندريًا',
      agender: 'عديم الجنس',
      twoSpirit: 'روحان',
      bigender: 'ثنائي الجنس',
      demiboy: 'نصف ولد',
      demigirl: 'نصف بنت',
      androgynous: 'خنثى',
      intersex: 'ثنائي الجنس',
      neutrois: 'محايد جنسيًا',
      pangender: 'متعدد الأجناس',
      polygender: 'متعدد الجنس',
      preferNotToSay: 'أفضل عدم الإفصاح',
      other: 'آخر'
    },
    orderType: {
      customerType: 'نوع العميل',
      lastContacted: 'آخر اتصال',
      nextFollowUp: 'المتابعة التالية',
      preferredContactTime: 'وقت الاتصال المفضل',
      preferredContactToTime: 'وقت الاتصال المفضل حتى',
      order: 'طلب',
      invoice: 'فاتورة',
      quote: 'عرض سعر',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      emailPhone: 'البريد الإلكتروني والهاتف',
      name: 'الاسم الأول والاسم الأخير',
      phone: 'الهاتف',
      address: 'العنوان',
      code: 'الرمز البريدي',
      pickDate: 'تاريخ الاستلام',
      pickOut: 'وقت الاستلام',
      licencePlate: 'لوحة السيارة',
      vehicleModel: 'طراز السيارة',
      vehicleColor: 'لون السيارة',
      contactedBy: 'الاتصال عبر',
      tellContact: 'أخبرنا كيف نتواصل معك بشكل أفضل',
      worker: 'الموظف',
      minAmountDelivery: 'الحد الأدنى لمبلغ التموين',
      minAmountPickUp: 'الحد الأدنى لمبلغ استلام التموين'
    },
    reservation: {
      availability: 'وقت الحجز الأسبوعي',
      reservations: 'الحجوزات',
      reservationDetail: 'تفاصيل الحجز',
      create: 'حجز جديد',
      reservationDate: 'تاريخ الحجز',
      reservationHour: 'وقت الحجز',
      timezone: 'المنطقة الزمنية',
      peoples: 'الأشخاص',
      serviceTime: 'الوقت المقدر للخدمة',
      reason: 'المناسبة',
      find: 'البحث عن حجز',
      enterCode: 'أدخل الرمز',
      yoursReservations: 'حجوزاتك',
      code: 'الرمز',
      completeDateReservacion: 'التاريخ',
      notcodefind: 'لا يوجد حجز مرتبط بهذا الرمز',
      state0: 'طلب',
      state1: 'تمت الموافقة',
      state2: 'تاريخ/وقت مقترح',
      state3: 'مرفوض',
      state4: 'تأكيد',
      state5: 'إلغاء',
      state6: 'إغلاق',
      Monday: 'الإثنين',
      Tuesday: 'الثلاثاء',
      Wednesday: 'الأربعاء',
      Thursday: 'الخميس',
      Friday: 'الجمعة',
      Saturday: 'السبت',
      Sunday: 'الأحد',
      all: 'الكل',
      restaurantHour: 'ساعات العمل',
      open: 'مفتوح',
      close: 'إغلاق الآن، المتابعة إلى الصفحة',
      errorHourCaterin: 'وقت التموين لـ ',
      errorHour: 'وقت الحجز لـ ',
      errorHour2: ' من ',
      discount: 'خصم',
      orderCloseToDiscount: "هذا الحجز مغلق، ولا يمكنك استخدام دفع عرض السعر هذا.",
      subtotalNotForDiscount: "لا يمكنك استخدام دفع عرض السعر هذا لأنه أكبر من المجموع الفرعي.",
      notDiscountToApply: 'لا يوجد خصم لتطبيقه',
      restaurantNotes: 'ملاحظة النشاط التجاري',
      quotationMessage1: 'معدل العشاء المدفوع مقدمًا هو ',
      quotationMessage2: 'وسيتم خصم هذا المبلغ من طلبك إذا قمت بالطلب منا. ',
      dinnerPrePayment: 'دفع مقدم للعشاء',
      timeToReserve: 'المدة بالدقائق ',
      available: 'متاح',
      notAvailable: 'غير متاح',
      deposit: 'وديعة الحجز',
      seatsAvailable: ' مقاعد متاحة',
      guestLocation: 'اختر موقع جميع ضيوفك',
      notGuestAvaibility: 'لا يوجد متسع لجميع ضيوفك',
      selectStaff: 'اختر موظفًا'
    },
    order: {
      item: 'العنصر',
      description: 'الوصف',
      quantity: 'الكمية',
      taxable: 'خاضع للضريبة؟',
      amount: 'المبلغ',
      tip: 'بقشيش',
      discount: 'خصم',
      creditCardFee: 'رسوم البطاقة الائتمانية',
      shipping: 'الشحن',
      trackShipping: "تتبع الشحن",
      packagesManagement: 'إدارة الحزم',
      tax: 'الضريبة',
      deposit: 'الوديعة',
      pendingAcceptance: 'في انتظار القبول',
      accepted: 'مقبول',
      prepare: 'تم التحضير',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      goBack: 'رجوع',
      orderDetail: 'تفاصيل الطلب',
      quoteDetail: 'تفاصيل عرض السعر',
      convertInvoice: 'تحويل إلى فاتورة',
      aceptQuote: 'قبول عرض السعر',
      productServicesUpdated: 'تم تحديث المنتجات/الخدمات',
      payInvoive: 'دفع الفاتورة',
      invoiceDetail: 'تفاصيل الفاتورة',
      invoiceNumber: 'رقم الفاتورة',
      invoiceTerm: 'الشروط',
      invoicePayed: 'تم دفع فاتورتك',
      shippingDate: 'تاريخ الشحن',
      shippingVia: 'طريقة الشحن',
      shippingTo: 'الشحن إلى',
      shippingFrom: 'الشحن من',
      shippingTrackingNumber: 'رقم التتبع',
      client: 'العميل',
      cart: 'السلة',
      productsOrdered: 'المنتجات المطلوبة',
      products: 'العناصر',
      name: 'الاسم',
      cant: 'الكمية',
      price: 'السعر',
      total: 'الإجمالي',
      otherCharges: 'رسوم إضافية',
      quotationPayment: 'دفع عرض السعر',
      cashPayment: 'دفع نقدي',
      isTicket: 'فتح الطلب كتذكرة',
      payAsTicket: 'تفويض الدفع ',
      sendInvoice: 'إرسال الفاتورة ',
      saveAsTicket: 'حفظ التذكرة',
      checkPayment: 'دفع بشيك',
      parcialPayment: 'دفع جزئي',
      quotationMessage1: 'رسومنا لعرض السعر هي ',
      quotationMessage2: 'وسيتم خصم هذا المبلغ من طلبك إذا طلبت منا. ',
      pendingPayment: 'دفع معلق',
      subtotal: 'المجموع الفرعي',
      taxe: 'الضرائب',
      deliver: 'التوصيل',
      tip: 'بقشيش',
      notes: 'ملاحظات',
      payment: 'تفاصيل الدفع',
      ccard: 'بطاقة ائتمان',
      ccode: 'رمز البطاقة',
      payWithThisCardQuestion: 'هل تريد الدفع بهذه البطاقة؟',
      cardEndingIn: 'بطاقة تنتهي بـ',
      yesPayNow: 'نعم، ادفع الآن',
      paymentSuccessful: 'تم الدفع بنجاح',
      paymentProcessed: 'تمت معالجة دفعتك بنجاح',
      expcard: 'تاريخ الانتهاء',
      dueDate: 'تاريخ الاستحقاق',
      pay: 'دفع',
      verify: 'التحقق من الدفع',
      transictionTitle: 'حالة المعاملة',
      transictionOk: 'تمت معاملتك بنجاح',
      sendRequest: 'إرسال طلب',
      requestCatering: 'تم إرسال الطلب. سيتصل بك مدير النشاط التجاري قريبًا.',
      transictionError: 'خطأ في تنفيذ الدفع',
      notValidCC: 'رقم بطاقة ائتمان غير صالح',
      yourOrders: 'طلباتك ',
      yourTicket: 'تذاكرك ',
      seeAll: 'عرض جميع الطلبات',
      orderState: ' حالة الطلب',
      cooker: ' الطباخ',
      type: 'النوع',
      state: 'الحالة',
      messageToast: "ما عليك سوى التسجيل لتتبع طلباتك وعرض سجل طلباتك. الأمر بهذه السهولة!",
      messgForContact: "ما عليك سوى التسجيل لتتبع طلباتك وعرض سجل طلباتك. الأمر بهذه السهولة!",
      messgForContactCatering: 'يجب عليك تسجيل الدخول لإنشاء طلب تموين',
      date: 'التاريخ',
      state0: 'دفع معلق',
      state1: 'تم الدفع',
      state2: 'في المطبخ',
      state3: 'تم التحضير',
      state4: 'في الطريق',
      state5: 'تم التسليم',
      state6: 'ملغى',
      state7: 'في انتظار المراجعة',
      state8: 'تمت الموافقة على التموين',
      state9: 'عرض سعر',
      state10: 'تم استلام الطلب',
      state11: 'متأخر',
      state12: 'إبطال',
      state13: 'تم الاسترداد',
      notOrder: 'ليس لديك طلبات معلقة',
      transId: 'المعاملة',
      invoice: 'الفاتورة',
      invoiceProposal: 'مقترح الفاتورة',
      invoiceProposalUpdated: 'تم تحديث مقترح الفاتورة',
      add: 'إضافة',
      share: 'مشاركة',
      remove: 'إزالة',
      edit: 'تعديل',
      cancelReason: 'سبب الإلغاء',
      paymentMethod: 'طريقة الدفع',
      orderFor: 'طلب لـ',
      other: 'أخرى',
      noTip: 'لا يوجد بقشيش',
      payed: 'تم الدفع',
      toPay: 'للدفع',
      readyForPick: 'سوف تتلقى رسالة نصية أو بريد إلكتروني عندما يكون طلبك جاهزًا للاستلام.',
      location: 'الموقع',
      hourToPickEstimated: 'الوقت المقدر للاستلام',
      dateToPickEstimated: 'التاريخ المقدر للاستلام',
      routingNumber: 'أرقام التوجيه البنكي',
      accountNumber: 'رقم الحساب',
      bankName: 'اسم البنك',
      badroutingNumber: 'رقم توجيه بنكي غير صحيح',
      eventName: 'اسم الحدث',
      guessNumber: 'عدد الضيوف',
      eventDate: 'تاريخ الحدث',
      messageDevice: 'يرجى الاتصال بالدعم في iMenuApps® لإضافة جهاز 973-969-1909 أو support@solutionsforsuccess.net',
      eventStartHour: 'وقت بدء الحدث',
      eventEndHour: 'وقت انتهاء الحدث',
      warningProductsTheOrderToCatering: 'أنت تحاول إضافة عنصر ليس من خدمة التموين. إذا كنت ترغب في المتابعة، فستفقد العناصر المضافة سابقًا. ',
      warningProductsTheCateringToOrder: 'أنت تحاول إضافة عنصر من خدمة التموين. إذا كنت ترغب في المتابعة، فستفقد العناصر التي أضفتها سابقًا. ',
      clientInfo: 'معلومات العميل',
      orderType: 'نوع الطلب',
      paymentByCard: 'الدفع ببطاقة الائتمان',
      totalForPay: 'الإجمالي للدفع',
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      postalCode: 'الرمز البريدي',
      addressLine1: 'العنوان',
      updateTicket: 'تحديث التذكرة',
      closeTicket: 'إغلاق التذكرة',
      closed: 'مغلق',
      requiredCustomer: 'بيانات العميل',
      requiredOrderType: 'نوع الطلب',
      culumnNumber: 'عدد الأعمدة في الصف'
    },
    tooltips: {
      addOrder: 'إضافة',
      printOrder: 'طباعة',
      forward: 'إعادة توجيه',
      reOrder: 'إعادة طلب',
      refreshOrder: 'تحديث',
      refreshCaptcha: 'تحديث الكابتشا',
      deleteOrder: 'إزالة',
      readyProduct: 'جاهز',
      printRes: 'طباعة',
      shareLocation: 'مشاركة الموقع',
      closeTicket: 'إغلاق',
      editTicket: 'تعديل',
      loadInfo: 'جارٍ تحميل بياناتك',
      loadRestaurant: 'جارٍ التحميل...',
      getToRestaurant: 'انقر هنا عند وصولك إلى موقع النشاط التجاري',
      carInRestaurant: 'السيارة وصلت إلى النشاط التجاري',
      carArrivedInfo: 'شكرًا لإعلامنا بأن سيارتك قد وصلت',
      errorRestaurantOffline: 'هذا النشاط التجاري غير مرئي للجمهور',
      deliveryPayment: 'دفع التوصيل'
    },
    payment: {
      splitPayment: 'تقسيم الدفع',
      splitIn: 'تقسيم إلى',
      splitMss: 'يجب أن تغطي المبالغ المدفوعة المبلغ الإجمالي للطلب. لا يمكن أن يكون أي دفعة 0 ',
      splitPay: 'الدفع #',
      splitToPay: 'دفع',
      splitPayed: 'تم الدفع',
      tjtPayment: 'بطاقة',
      creditPayment: 'ائتمان',
      devicePayment: 'جهاز',
      idtechPayment: 'Moto/Swipe',
      swipePayment: 'تمرير',
      cashPayment: 'نقدًا',
      hcaPayment: 'ACH',
      housePayment: 'حساب المنزل',
      checkPayment: 'شيك',
      sharePayment: 'مشاركة الدفع',
      qrPayment: 'دفع QR',
      verifyMss: 'بعد التأكد من إجراء الدفع، تحقق من الدفع لحفظ الطلب، أو إلغاء لعدم متابعة هذا الدفع.',
      doingPayment: 'جارٍ الدفع',
      authorizingPayment: 'جارٍ تفويض الدفع',
      insuficientFunds: 'رصيد غير كافٍ',
      quoteExpired: 'عذرًا. انتهى الوقت المخصص لهذا العرض',
      quoteChanged: 'تم تعديل العرض، وهو في حالة',
      quoteAcepted: 'تم قبول العرض',
      goodPayment: 'تم الدفع',
      shareText1: ' شارك رابط دفع لطلب الطعام المقدم في نشاطنا التجاري ',
      shareText1a: ' شارك رابط دفع للحجز المقدم في نشاطنا التجاري ',
      shareText2: '. يرجى متابعة الرابط أدناه لإجراء الدفع. شكرًا لك!'
    },
    createNew: {
      businessTemplate: 'قالب النشاط التجاري',
      restaurantName: 'اسم النشاط التجاري',
      restaurantAddres: 'عنوان النشاط التجاري',
      restaurantPhone: 'هاتف النشاط التجاري',
      restaurantEmail: 'بريد النشاط التجاري الإلكتروني',
      restaurantZipcode: 'الرمز البريدي للنشاط التجاري',
      restaurantWeb: 'موقع النشاط التجاري الإلكتروني',
      restaurantFax: 'فاكس النشاط التجاري',
      merchantName: 'اسم التاجر الأول',
      merchantLastName: 'اسم التاجر الأخير',
      merchantAddres: 'عنوان التاجر',
      merchantZipcode: 'الرمز البريدي',
      merchantPhone: 'رقم هاتف التاجر',
      merchantEmail: 'بريد التاجر الإلكتروني',
      merchantClerk: 'رمز المستخدم (1 - 99999)',
      createTitle: 'إنشاء نشاط تجاري جديد في iMenuApps®',
      dataRestaurant: 'تفاصيل النشاط التجاري',
      dataMercahnt: 'بيانات التاجر',
      restaurants: 'الأنشطة التجارية',
      createdMessage: 'تم إنشاء النشاط التجاري بنجاح. سوف تتلقى بريدًا إلكترونيًا بكلمة المرور للوصول إلى التطبيق ',
      clerkToLong: 'تجاوزت قيمة الرمز، الحد الأقصى المسموح به 99999',
      clerkNotValid: 'رمز غير صالح',
      reciveSubscription: 'تريد تلقي إشعارات من',
      activateSubscription: 'تريد تفعيل الإشعارات لـ',
      saving: 'جارٍ حفظ النشاط التجاري',
      recordSaving: 'جارٍ الحفظ',
      active: 'نشط',
      inactive: 'غير نشط',
      restaurantType: 'نوع النشاط التجاري',
      template: 'قالب',
      chooseBusinessTemplate: 'اختر قالب النشاط التجاري',
      select: 'اختر',
      temrsAndCondition: 'الشروط والأحكام',
      trialDate: 'يوم تجريبي',
      trialMss: 'جرب لمدة 14 يومًا',
      business: 'النشاط التجاري',
      reservation: 'الحجز'
    },
    unsubscribe: {
      title: 'إلغاء الاشتراك',
      email: 'البريد الإلكتروني',
      unsubscribeOk: 'تم إلغاء اشتراك بريدك الإلكتروني بنجاح',
      unsubscribeFail: 'خطأ. البريد الإلكتروني غير موجود ',
      restaurantFail: 'النشاط التجاري غير موجود'
    },
    specialsPrice: {
      titles: 'أسعار خاصة',
      title: 'سعر خاص',
      name: 'الاسم',
      type: 'النوع',
      amount: 'المبلغ',
      for: 'إلى',
      apply: 'تطبيق',
      active: 'نشط',
      repite: 'تكرار',
      oneStarDate: 'تاريخ ووقت البدء',
      oneEndDate: 'تاريخ ووقت الانتهاء',
      weekStarDate: 'وقت البدء',
      weekEndDate: 'وقت الانتهاء',
      monthStardDat: 'يوم الشهر',
      annualStartDat: 'الشهر ويوم السنة',
      activeRule: 'سيتم تطبيق قاعدة واحدة فقط في كل مرة. القاعدة الأولى التي يتم تفعيلها ستحظى بالأولوية.'
    },
    credit: {
      state0: 'مطلوب',
      state1: 'مقبول',
      state2: 'ملغى',
      state3: 'مغلق',
      yourCredit: 'ائتماناتك',
      amount: 'مبلغ الائتمان',
      debt: 'الدين',
      createDate: 'تاريخ الإنشاء',
      active: 'نشط',
      dateFrom: 'تاريخ البدء',
      dateTo: 'تاريخ الانتهاء',
      paymentDate: 'تاريخ الدفع',
      state: 'الحالة',
      pendingPay: 'دفع معلق',
      payed: 'تم الدفع',
      creditpayed: 'تم دفع الائتمان',
      mssPay1: 'العميل ',
      mssPay2: 'قام بدفع ائتمان ',
      mssPay3: 'بمبلغ '
    }
  }
}
